const orgListR4 = [
  {
    Hospital: "Access Community Health Network",
    Endpoint:
      "https://eprescribing.accesscommunityhealth.net/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.myaccesshealth.net/myaccesshealth/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Adult & Pediatric Ear, Nose & Throat – Kalamazoo",
    Endpoint: "https://hygieia.bronsonhg.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.bronsonhealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "AdvantageCare Physicians",
    Endpoint: "https://epwebapps.acpny.com/FHIRproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.acpny.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "AdventHealth",
    Endpoint: "https://mobile.adventhealth.com/oauth2-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://account.adventhealth.com/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Akron Children's Hospital",
    Endpoint: "https://haiku-canto-prod.chmca.org/ARR-FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.akronchildrens.org/mychart/Authentication/Login?mode=stdfile&option=proxylandingpage",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Alameda Health System",
    Endpoint: "https://epicproxy.et1075.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.alamedahealthsystem.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Allegheny Health Network",
    Endpoint: "https://epicprisfd.ahn.org/PRD-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ahn.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Allina Health System",
    Endpoint: "https://webproxy.allina.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://account.allinahealth.org/registration",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Altais",
    Endpoint: "https://epicproxy.et1138.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.altais.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "AltaMed",
    Endpoint: "https://epicproxy.et1123.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.myaltamed.net/MyAltaMed/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Altru Health System",
    Endpoint: "https://epicsoap.altru.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.altru.org/myhealth/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "AnMed Health",
    Endpoint: "https://epicproxy.et0971.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.anmedhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Ardent",
    Endpoint: "https://epicproxy.ardenthealth.com/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ardenthealth.com/PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Arizona Community Physicians",
    Endpoint:
      "https://interconnect.azacp.com/interconnect-oauth2-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.azacp.com/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Arkansas Children's",
    Endpoint: "https://fhir.archildrens.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://go.archildrens.org/WR-2019-08-MyChartOnlineSignUp_LP-MyChart-Online-Sign-Up.html",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Arrowhead Regional Medical Center",
    Endpoint: "https://epicproxy.et1152.epichosted.com/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.arrowheadregional.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Asante Health Systems",
    Endpoint: "https://epicmobile.asante.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.asante.org/MyChart-AHS/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Ascension Illinois",
    Endpoint: "https://epicmobile.presencehealth.org/fhirPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.presencehealth.org/mychart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Ascension Providence",
    Endpoint: "https://stofo.providence-waco.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychartwa.providence.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Aspen Valley Hospital",
    Endpoint: "https://epicproxy.et1254.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.aspenhospital.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Aspirus",
    Endpoint: "https://erx.aspirus.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myaspirus.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Atlantic Health",
    Endpoint: "https://soapproxy.atlantichealth.org/FHIRPrd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.atlantichealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Atrium – Morehouse Healthcare",
    Endpoint:
      "https://epicproxy.et0905.epichosted.com/FHIRproxy/MHC/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://my.atriumhealth.org/myatriumhealth/publicforms.asp?mode=showform&formname=SignUpOne",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Atrium Health",
    Endpoint: "https://epicproxy.et0905.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://my.atriumhealth.org/myatriumhealth/publicforms.asp?mode=showform&formname=SignUpOne",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Atrium Health Wake Forest Baptist",
    Endpoint: "https://w1soap.wakehealth.edu/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://my.atriumhealth.org/myatriumhealth/publicforms.asp?mode=showform&formname=SignUpOne",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Atrius Health",
    Endpoint: "https://iatrius.atriushealth.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealth.atriushealth.org/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Aurora Health Care - LiveWell",
    Endpoint: "https://EpicFHIR.aurora.org/FHIR/LiveWell/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://livewell.aah.org/Chart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Austin Regional Clinic",
    Endpoint: "https://mobileprod.arcmd.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.austinregionalclinic.com/mychart/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Ballad Health",
    Endpoint: "https://soap.wellmont.org/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.balladhealth.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Baptist Health - Northeast Florida",
    Endpoint: "https://epicproxy.et1206.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.baptistchart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Baptist Health – KY & IN",
    Endpoint: "https://epicproxy.bhsi.com/PRD-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.baptisthealth.com/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Baptist Health (Arkansas)",
    Endpoint: "https://api.baptist-health.org/Interconnect-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.baptist-health.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Baptist Memorial Health Care",
    Endpoint: "https://rxedi.bmhcc.org/prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.baptistonecare.org/PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Bassett Healthcare",
    Endpoint: "https://soap.bassett.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.mybassetthealthconnection.org/MyChart-PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "BayCare Clinic - myBayCare",
    Endpoint: "https://EpicFHIR.aurora.org/fhirproxy/MYBAYCARE/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://my.baycare.net/BaycareClinicsMyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Bayhealth Medical Center",
    Endpoint: "https://epproxy.bayhealth.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://epmychart.bayhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Baylor College of Medicine",
    Endpoint: "https://fhir.clinical.bcm.edu/stage1fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.bcm.edu/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Baylor Scott & White",
    Endpoint: "https://epicproxy.bswhealth.org/FHIR-PRD/BSW/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.bswhealth.com/login",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Beaumont Health",
    Endpoint: "https://moc.beaumont.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mybeaumontchart.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Bellin Health",
    Endpoint: "https://arr.thedacare.org/FHIR/BLN/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mybellin.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Beth Israel Lahey Health",
    Endpoint: "https://fhir.laheyhealth.org/proxy-prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://bilh.org/patient-portal",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "BJC & Washington University",
    Endpoint: "https://epicproxy.et0965.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mypatientchart.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Bon Secours Health System",
    Endpoint: "https://haiku.bshsi.org/fhir/BSHSI_OAUTH/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.bonsecours.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Boston Medical Center",
    Endpoint: "https://emerge-soap1.bmc.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.bmc.org/MyChart/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Boulder Community Health",
    Endpoint: "https://prevprox.bch.org/FHIRproxyPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.bch.org/MyChartPRD/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Bozeman Health",
    Endpoint:
      "https://revproxy.bh.bozemanhealth.org/Interconnect-Oauth2-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mc.bh.bozemanhealth.org/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Bronson Healthcare Group",
    Endpoint: "https://hygieia.bronsonhg.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.bronsonhealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Brookwood Baptist Health",
    Endpoint: "https://epicproxy.bhsala.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.bhsala.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Bryan Health",
    Endpoint: "https://epicproxy.et1031.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.bryanhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Buffalo Medical Group",
    Endpoint: "https://fhir.buffalomedicalgroup.com/fhir-arr/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mybmgchart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Caldera Family Medicine",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://caldera.epicmychart.com/cfm/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cambridge Health Alliance",
    Endpoint:
      "https://epicmobile.challiance.org/Interconnect-oauth2/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.challiance.org/Mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cape Cod Healthcare",
    Endpoint: "https://epicproxy.et1149.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.capecodhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cape Fear Valley Health",
    Endpoint: "https://epicproxy.et1094.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.capefearvalley.com/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Care New England",
    Endpoint: "https://cnesp001.carene.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.carene.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Carilion Clinic",
    Endpoint: "https://fhir.carilionclinic.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.carilionclinic.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Carle Foundation Hospital & Physician Group",
    Endpoint: "https://epicproxy.et0316.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mycarle.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Caromont Health",
    Endpoint: "https://spp.caromonthealth.org/FhirProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.caromonthealth.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cascade Internal Medicine",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://cascadeinternal.epicmychart.com/cim/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Catholic Health (Long Island NY)",
    Endpoint: "https://epx1.chsli.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.chsli.org/MyChartProd/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Catholic Health System (Buffalo)",
    Endpoint: "https://epicproxy.et1144.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.chsbuffalo.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cedars-Sinai Health System",
    Endpoint: "https://cslinkmobile.csmc.edu/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mycslink.cedars-sinai.org/mycslink/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CentraCare Health and Affiliates",
    Endpoint: "https://epicmobile.centracare.com/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.centracare.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Central Ohio Primary Care Physicians",
    Endpoint: "https://rp-prd.copcp.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.copcp.com/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Centura Health",
    Endpoint: "https://epic-p-mobile.centura.org/prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://epic.mycenturahealth.org/MCH/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Charlotte Eye Ear Nose & Throat Associates",
    Endpoint: "https://fhirprd.ceenta.com/proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myceentachart.com/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Chesapeake Regional Medical Center",
    Endpoint: "https://haiku.bshsi.org/fhir/CRMC_OAUTH/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.chesapeakeregional.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cheyenne Regional Medical Center",
    Endpoint: "https://soap.crmcwy.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.crmcwy.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CHI Health",
    Endpoint: "https://rp.chihealth.com/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.chihealth.com/PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CHI Memorial",
    Endpoint: "https://rpsouth.catholichealth.net/fhir/FHIRMCT/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.memorial.org/TN/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CHI Saint Joseph Health",
    Endpoint: "https://rpsouth.catholichealth.net/fhir/FHIRKY/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.chisaintjosephhealth.org/KY/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CHI St. Alexius Health",
    Endpoint: "https://rp.chihealth.com/fhir/FHIRSTA/api/FHIR/R4",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychartsta.chihealth.com/STAPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CHI St. Luke's Health",
    Endpoint: "https://rpsouth.catholichealth.net/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.sleh.com/TX/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Children's Health System of Texas",
    Endpoint: "https://fhir.childrens.com/prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.childrens.com/MyChart/publicforms.asp?mode=showform&formname=ProxyAccessRequest",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Children's Hospital and Medical Center, Omaha Nebraska",
    Endpoint: "https://EPROXY1.chsomaha.org/FHIRPROXY/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://connect.childrensomaha.org/MyChart/publicforms.asp?mode=showForm&formname=ActivationReq",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Children's Hospital Colorado",
    Endpoint: "https://fhir.childrenscolorado.org/fhirprd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.childrenscolorado.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Children's Hospital of Philadelphia",
    Endpoint: "https://epicnsproxy.chop.edu/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychop.chop.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Children's of Alabama",
    Endpoint: "https://epicproxy.et1246.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.childrensal.org/MyChart/Authentication/Login?mode=stdfile&option=ProxyAccessReqLandingPg",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Children's Wisconsin",
    Endpoint: "https://epicproxy.et0815.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.chw.org/MyChart/publicforms.asp?mode=showForm&formname=AccessCodeRequest",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Childrens's Healthcare of Atlanta",
    Endpoint: "https://wpprod.choa.org/FHIR_PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.choa.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CHRISTUS Health",
    Endpoint: "https://proxy.christushealth.org/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.christushealth.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cincinnati Children's Hospital Medical Center",
    Endpoint: "https://boomer.cchmc.org/fhir/api/fhir/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.cincinnatichildrens.org/MyChart/cchmc-online-enroll.html",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "City of Hope",
    Endpoint:
      "https://epic-rproxyprod.coh.org/Interconnect-FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mycityofhope.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cleveland Clinic",
    Endpoint: "https://api.ccf.org/mu/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.clevelandclinic.org/public/signup/",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Columbia Physicians",
    Endpoint:
      "https://epicproxy-pub.et1089.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.columbiadoctors.org/patients/access-connect",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Columbus Regional Health",
    Endpoint: "https://epicprdproxy.crh.org/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.crh.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Community Health Network",
    Endpoint: "https://esp.ecommunity.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ecommunity.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Community Healthcare System",
    Endpoint: "https://webproxy.comhs.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.comhs.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Community Medical Centers",
    Endpoint: "https://epicsoapprd.communitymedical.org/arr_fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.communitymedical.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Community Technology Cooperative",
    Endpoint: "https://epicproxy.et1290.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychartepic.c3ctc.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CommUnityCare Health Centers",
    Endpoint: "https://epicproxy.et1164.epichosted.com/FHIRproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.ochin.org/MyChartSeattleroots/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cone Health",
    Endpoint: "https://epsoap.conehealth.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.conehealth.com/MyChart//signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Conemaugh Health System",
    Endpoint: "https://fhir.conemaugh.org/arr-fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.conemaugh.org/MyChart-2017-PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Confluence Health",
    Endpoint: "https://epicproxy.et0764.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.confluencehealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Connecticut Children's Medical Center",
    Endpoint: "https://epicproxy.connecticutchildrens.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.connecticutchildrens.org/MYC-PRD/publicforms.asp?mode=showform&formname=signupform",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Contra Costa",
    Endpoint: "https://icproxy.mycclink.org/proxy-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.cchealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cook Children’s Health Care System",
    Endpoint: "https://cookicfg.cookchildrens.org/CookFHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.cookchildrens.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cooper University Health Care",
    Endpoint: "https://epicproxy.et0578.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.cooperhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Cottage Health",
    Endpoint: "https://eparp.sbch.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.sbch.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Covenant Health",
    Endpoint: "https://haiku.bshsi.org/fhir/COV_OAUTH/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.covh.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Covenant HealthCare",
    Endpoint: "https://epichaiku.chs-mi.com/FHIRPROXY/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.chs-mi.com/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "CVS Health & Minute Clinic",
    Endpoint: "https://retailepicfhir.cvshealth.com/FhirProxy/api/fhir/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.cvshealth.com/MyChartPRD/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Dartmouth-Hitchcock",
    Endpoint: "https://edhwebportal.hitchcock.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://portal.mydh.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "DaVita Physician Solutions",
    Endpoint: "https://epicproxy.et1087.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.davitaphysiciansolutions.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Dayton Children's Hospital",
    Endpoint:
      "https://appprd.childrensdayton.org/interconnect-prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mykidschart.childrensdayton.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Deaconess Health System",
    Endpoint: "https://eprp.deaconess.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.viewmychart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Denver Health",
    Endpoint: "https://webservices.dhha.org/PRD-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.denverhealth.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Drexel Medicine",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://drexel.epicmychart.com/drx/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Driscoll Children's Hospital",
    Endpoint: "https://fhir.dchstx.org/FHIR-External/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.dchstx.org/MyChart/publicforms.asp?mode=showForm&formname=ActivationReqSelf",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Duke Health",
    Endpoint: "https://health-apis.duke.edu/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.dukemychart.org/Home/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Duly Health and Care",
    Endpoint:
      "https://epicproxy.et1296.epichosted.com/APIProxyPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.dupagemd.net/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "East Boston Neighborhood Health Center",
    Endpoint: "https://ebmobile14.ebnhc.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.ebnhc.org/mychart/accesscheck.asp?lang=english",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "East Cascades Women's Group",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://eastcascadewomens.epicmychart.com/ecwg/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Edward-Elmhurst Healthcare",
    Endpoint: "https://fhirprd.edward.org/fhirprd/EEHOAUTH/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.eehealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Eisenhower Medical Center",
    Endpoint: "https://epicarr.emc.org/EMC_FHIR_PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.eisenhowerhealth.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "El Camino Hospital",
    Endpoint: "https://rwebproxy.elcaminohospital.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mycare.elcaminohospital.org/MyChart/Authentication/Login?mode=stdfile&option=signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "El Rio Health",
    Endpoint: "https://epicproxy.et1240.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://elriomychart.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Emory Healthcare",
    Endpoint: "https://epicrp-prd.eushc.org/OAUTH2-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.emoryhealthcare.org/MyChart-prd/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Englewood Hospital and Medical Center",
    Endpoint: "https://epicproxy.et1073.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.englewoodhealth.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Enloe Health",
    Endpoint: "https://epicproxy.et1034.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.enloe.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "EPIC Management (Beaver Medical Group)",
    Endpoint: "https://epicproxy.et1038.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mybeaverchart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Erlanger Health System",
    Endpoint: "https://epicproxy.et0967.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.erlanger.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Eskenazi Health",
    Endpoint: "https://proxy.eskenazihealth.edu/FHIR-Proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.eskenazihealth.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Essentia Health",
    Endpoint: "https://m.essentiahealth.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://communityconnect.essentiahealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Fairview Health Services",
    Endpoint: "https://sfd.fairview.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.fairview.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Fall Creek Internal Medicine",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://fallcreek.epicmychart.com/fcim/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Family Care Network",
    Endpoint: "https://epicproxy.fcn.net/Fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.fcn.net/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Family Health Center (Michigan)",
    Endpoint: "https://hygieia.bronsonhg.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.fhckzoo.com/MyChartFHC/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "FastMed",
    Endpoint: "https://external.fastmed.com/FHIRproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.fastmed.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "FirstHealth of the Carolinas",
    Endpoint: "https://epicrp.firsthealth.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.firsthealthmychart.org/mychartprd/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Foothill Family Clinic",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://foothill.epicmychart.com/ffc/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Franciscan Alliance",
    Endpoint: "https://ema.franciscanalliance.org/FHIR_PROXY/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.franciscanmychart.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Franciscan Missionaries of Our Lady Health System",
    Endpoint: "https://epicproxy.et0830.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.fmolhs.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Fresenius Medical Care North America",
    Endpoint: "https://epicproxy.et1041.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://patientlogin.fmcna.com/auth/realms/patienthub/login-actions/registration?client_id=https%3A%2F%2Ffmcna-healthcloud.my.salesforce.com&tab_id=bkTrM37n6R8",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Froedtert Health",
    Endpoint: "https://epicserviceGW.froedtert.com/FHIRProxyPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.my.froedtert.com/MyChartFS/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Garnet Health",
    Endpoint: "https://epic.garnethealth.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.garnethealth.org/GH/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Genesis Healthcare System",
    Endpoint: "https://fhir.genesishcs.org/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.genesishcs.org/MyChart/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "George Washington University Medical Faculty Associates",
    Endpoint: "https://epicproxy.et1222.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.gwdocs.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Golden Valley Health Centers",
    Endpoint: "https://ep-rps.gvhc.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.gvhc.org/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Grady Health System",
    Endpoint: "https://surescripts.gmh.edu/OAuth2PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.gradyhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Greater Baltimore Medical Center",
    Endpoint: "https://eportal.gbmc.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://eportal.gbmc.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Group Health Cooperative - South Central Wisconsin",
    Endpoint: "https://linkpoint.ghcscw.com/Interconnect-prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://ghcmychart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Gundersen Health System",
    Endpoint: "https://scproxy.gundersenhealth.org/FHIRARR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.gundersenhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hackensack Meridian Health",
    Endpoint: "https://mepic.hmhn.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.hmhn.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hamilton Health Care System",
    Endpoint: "https://epicproxy.et1336.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.hamiltonhealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Harris Health System",
    Endpoint: "https://fhir.harrishealth.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealth.harrishealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hattiesburg Clinic and Forrest General Hospital",
    Endpoint: "https://soapprod.hattiesburgclinic.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://iris.forrestgeneral.com/Iris/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hawaii Pacific Health",
    Endpoint: "https://webservices.hawaiipacifichealth.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.hawaiipacifichealth.org/web/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "HCA Central and West Texas",
    Endpoint: "https://stdavidsfhirprd.app.medcity.net/fhir-proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealthone.com/mh1/public/mh1/Login/#/signup-form",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "HCA Mountain",
    Endpoint:
      "https://mountainstarhealthfhirprd.app.medcity.net/fhir-proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.mountainstarhealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "HCA South Atlantic",
    Endpoint:
      "https://memorialhealthfhirprd.app.medcity.net/fhir-proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealthone.com/mh1/public/mh1/Login/#/signup-form",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Health Choice Network",
    Endpoint: "https://epicproxy.et1256.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.hcnetwork.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "HealthPartners",
    Endpoint: "https://proxy.healthpartners.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.healthpartners.com/account/create/start",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hendricks Regional Health",
    Endpoint: "https://sehproxy.stelizabeth.com/arr-fhir/HRH/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.hendricks.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hennepin Healthcare",
    Endpoint: "https://hie.hcmed.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.hcmed.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Henry Ford Health System",
    Endpoint: "https://fhir.hfhs.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.hfhs.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Highland District Hospital",
    Endpoint: "https://epicscripts.trihealth.com/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.hdh.org/MyChartConnect//signup/",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hill Physicians",
    Endpoint: "https://epicproxy.et1013.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.myhillchart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hoag Memorial Hospital Presbyterian",
    Endpoint: "https://epicproxy.et1197.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.hoagconnect.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "HonorHealth",
    Endpoint:
      "https://interconnect.honorhealth.com/Interconnect-FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.honorhealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hospital for Special Surgery",
    Endpoint: "https://epicproxy.et0927.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhss.hss.edu/MyHSS/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hospital Sisters Health System (HSHS)",
    Endpoint: "https://scripts.prevea.com/FHIR-ARR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.myhshs.org/MyHSHS/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Houston Methodist",
    Endpoint: "https://epicproxy.et0922.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.houstonmethodist.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Hurley Medical Center",
    Endpoint: "https://fhir.hurleymc.com/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.hurleymc.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Illinois Bone & Joint Institute",
    Endpoint: "https://epicproxy.et1195.epichosted.com/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ibji.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Infirmary Health",
    Endpoint: "https://ssproxyprod.infirmaryhealth.org/epicFHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.myihchart.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Innovage",
    Endpoint: "https://rp.innovage.com/OAUTH2-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.innovage.com/mychartprd/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Inova Health System",
    Endpoint: "https://epicrpprd.inova.org/fhirrp/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.inova.org/mychart-signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Institute for Family Health",
    Endpoint: "https://epicproxy.institute.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.institute.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "INTEGRIS Health",
    Endpoint: "https://FHIR.Integrisok.com/Interconnect-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://integrisandme.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Intermountain Healthcare",
    Endpoint: "https://sclprdproxy.sclhs.net/FHIRPRD-2017/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealthplus.intermountainhealthcare.org/landing",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Jefferson Health",
    Endpoint: "https://fhir.jefferson.edu/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.jeffersonhealth.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "John Muir Health",
    Endpoint: "https://fhir.johnmuirhealth.com/fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.johnmuirhealth.com/mychartmcmprd/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Johns Hopkins Medicine",
    Endpoint: "https://epicmobile.johnshopkins.edu/FHIR_PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.hopkinsmedicine.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "JPS Health Network",
    Endpoint: "https://oauth2.revprxprd.jpshealth.org/epoauth2/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://jpsmychart.jpshealth.org/jpsmychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kaiser Permanente - California - Northern",
    Endpoint:
      "https://FHIR.KP.ORG/service/ptnt_care/EpicEdiFhirRoutingSvc/v2014/esb-envlbl/312/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://healthy.kaiserpermanente.org/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kaiser Permanente - California - Southern",
    Endpoint:
      "https://fhir.kp.org/service/ptnt_care/EpicEdiFhirRoutingSvc/v2014/esb-envlbl/212/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://healthy.kaiserpermanente.org/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kaiser Permanente - Colorado",
    Endpoint:
      "https://fhir.kp.org/service/ptnt_care/EpicEdiFhirRoutingSvc/v2014/esb-envlbl/140/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://healthy.kaiserpermanente.org/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kaiser Permanente - Maryland/Virginia/Washington D.C.",
    Endpoint:
      "https://fhir.kp.org/service/ptnt_care/EpicEdiFhirRoutingSvc/v2014/esb-envlbl/170/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://healthy.kaiserpermanente.org/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kaiser Permanente - Washington",
    Endpoint: "https://fhir.kp.org/Interconnect-FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://healthy.kaiserpermanente.org/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kaiser Permanente – Georgia",
    Endpoint:
      "https://fhir.kp.org/service/ptnt_care/EpicEdiFhirRoutingSvc/v2014/esb-envlbl/200/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://healthy.kaiserpermanente.org/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kaiser Permanente – Oregon – SW Washington",
    Endpoint:
      "https://FHIR.KP.ORG/service/ptnt_care/EpicEdiFhirRoutingSvc/v2014/esb-envlbl/190/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://healthy.kaiserpermanente.org/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kaiser Permanente Hawaii / Maui Health System",
    Endpoint:
      "https://fhir.kp.org/service/ptnt_care/EpicEdiFhirRoutingSvc/v2014/esb-envlbl/130/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://healthy.kaiserpermanente.org/register",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kalamazoo College Student Health Center",
    Endpoint: "https://hygieia.bronsonhg.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.kzoo.edu/MyChartKzoo/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kalamazoo Foot Surgery",
    Endpoint: "https://hygieia.bronsonhg.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.bronsonhealth.com/MyChartKFS/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kelsey-Seybold Clinic",
    Endpoint: "https://ssrx.ksnet.com/FhirProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mykelseyonline.com/Mychart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kennedy Krieger Institute",
    Endpoint: "https://epicproxy.et1095.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.kennedykrieger.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kettering Health Network",
    Endpoint: "https://khnarr.ketthealth.com/FHIR-PROD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ketteringhealth.org/MyChartPRD/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "KeyCare",
    Endpoint: "https://epicproxy.et1284.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.keycare.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "King's Daughters Medical Center",
    Endpoint: "https://arrprd.kdmc.net/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.kdmc.net/MyChartProduction/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Kootenai Health",
    Endpoint: "https://soapprod.multicare.org/FHIRProxy/KH/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://kh.ccmychart.org/KH/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Lakeland Regional Health (FL)",
    Endpoint: "https://epicapp.mylrh.org/OAuth2/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mylrh.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "LCMC Health",
    Endpoint: "https://interconnect.lcmchealth.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://patientportal.lcmchealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Lee Health",
    Endpoint: "https://epicedi.leememorial.org/FHIR-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.leememorial.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Legacy Health",
    Endpoint: "https://lhspdxfhirprd.lhs.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealth.lhs.org/MyHealth/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Lehigh Valley Health Network",
    Endpoint: "https://proxy.lvh.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mylvhn.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Leon Medical Centers",
    Endpoint:
      "https://prodinterconnect.leonmedicalcenters.com/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://leonmediconnect.com/MyChartLeonMediConnect/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Lexington Medical Center",
    Endpoint: "https://lmcrcs.lexmed.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.lexmed.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Licking Memorial Health Systems",
    Endpoint: "https://epicproxy.et1168.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.lmhealth.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Lifespan",
    Endpoint: "https://lsepprdsoap.lifespan.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.lifespan.org/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Loma Linda University Health and CareConnect Partners",
    Endpoint: "https://fhir.lluh.org/interconnect-fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mylluhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Loyola Medicine",
    Endpoint: "https://rxhub.luhs.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myloyola.luhs.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Luminis Health",
    Endpoint: "https://epicarr.aahs.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.aahs.org/MyChartAccess/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Main Line Health",
    Endpoint: "https://epicproxy.et1007.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.mainlinehealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mary Greeley Medical Center (Iowa)",
    Endpoint: "https://emrproxy.mcfarlandclinic.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.mychartiowa.com/MyChartPRD/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mary Washington Healthcare",
    Endpoint: "https://epicproxy.et1055.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mwhc.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mass General Brigham",
    Endpoint:
      "https://ws-interconnect-fhir.partners.org/Interconnect-FHIR-MU-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://patientgateway.massgeneralbrigham.org/MyChart-PRD/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mayo Clinic",
    Endpoint: "https://mcc.api.mayo.edu/epic-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://signup.mayoclinic.org/?ApplicationID=24e83c70-19b1-4a2f-9412-fd5838c56be7",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "McFarland Clinic (Iowa)",
    Endpoint: "https://emrproxy.mcfarlandclinic.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mychartiowa.com/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "McLeod Health",
    Endpoint: "https://epicproxy.et1267.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mcleodmychart.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Medical University of South Carolina",
    Endpoint: "https://fhirprod.musc.edu/fhirprod/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.musc.edu/mychart/Signup/",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "MediSys Health Network",
    Endpoint: "https://eprescribe-p.medisys.org/fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.medisys.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Memorial Healthcare System",
    Endpoint: "https://mhssp.mhs.net/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mhs.net/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Memorial Hospital and Health Care Center",
    Endpoint: "https://arrprd.mhhcc.org/OAuth2/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mhs.net/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "MemorialCare",
    Endpoint: "https://fhir.memorialcare.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mymemorialcare.memorialcare.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mercy Health - OH, KY",
    Endpoint: "https://chperx.health-partners.org/Proxy-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://chpepiceweb.health-partners.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mercy Health (Arkansas, Louisiana, Mississippi and Texas)",
    Endpoint: "https://epic-fhir.mercy.net/prdfhirstl/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mercy.net/app/registration",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mercy Health Services (MD)",
    Endpoint: "https://surescripts.mdmercy.com/fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mdmercy.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mercy Health System - WI",
    Endpoint: "https://epicproxy.mhsjvl.org/FHIRproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.mercyhealthsystem.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mercy Medical Center",
    Endpoint: "https://eproxy.mercycare.org/oauth2/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mdmercy.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Meritus",
    Endpoint:
      "https://epicproxy.et1062.epichosted.com/FHIRProxyPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.meritushealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Methodist Health System",
    Endpoint: "https://epcapp.mhd.com/arr-prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.methodisthealthsystem.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Methodist Hospitals",
    Endpoint: "https://mychart.methodisthospitals.org/FHIR-ARR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.methodisthospitals.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Metro Health - Michigan",
    Endpoint: "https://arrprd.metrohealth.net/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.metrohealth.net/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "MetroHealth - OH",
    Endpoint: "https://fhir.metrohealth.org/fhir_prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.metrohealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Michigan Medicine",
    Endpoint: "https://mcproxyprd.med.umich.edu/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.myuofmhealth.org/MyChart-PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Middlesex Hospital",
    Endpoint: "https://epicproxy.et1124.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.middlesexhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Midwestern University",
    Endpoint:
      "https://epicproxy.et1329.epichosted.com/APIProxyPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mwuclinics.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mohawk Valley Health System",
    Endpoint: "https://fhir.mvhealthsystem.org/FHIRproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mvhealthsystem.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Molina Care Connections",
    Endpoint: "https://epicproxy.et1057.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.molinahealthcare.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Montage Health",
    Endpoint: "https://epicproxy.et1058.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.montagehealth.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Montefiore Medical Center",
    Endpoint: "https://soapepic.montefiore.org/FhirProxyPrd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.montefiore.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Monument Health",
    Endpoint:
      "https://ehrmobile.monument.health/interconnect-prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.monument.health/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mosaic Life Care",
    Endpoint: "https://epicproxy.et1274.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mymlc.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mount Auburn Hospital",
    Endpoint: "https://fhir.mah.org/prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mah.org/mychart/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mount Sinai Health System",
    Endpoint: "https://epicsoapproxyprd.mountsinai.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mountsinai.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Mount Sinai Medical Center",
    Endpoint: "https://epicfhir.msmc.com/proxysite-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.msmc.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "MultiCare Health System",
    Endpoint: "https://soapprod.multicare.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.multicare.org/MyMultiCare/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Muscogee - Creek Nation Department of Health",
    Endpoint: "https://epicproxy.et1221.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.creekhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "MY DR NOW",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mydrnow.epicmychart.com/mdn/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "MyMichigan Health",
    Endpoint: "https://arrprod.midmichigan.net/ProdFHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.midmichigan.net/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Nationwide Children's Hospital",
    Endpoint: "https://hkc.nationwidechildrens.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.nationwidechildrens.org/MyChart/publicforms.asp?mode=showForm&formname=ActivationReq",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "NCH Healthcare System",
    Endpoint: "https://epicproxy.et1233.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.nch.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Nebraska Medicine",
    Endpoint: "https://ocsoapprd.nebraskamed.com/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.onechartpatient.com/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Nemours",
    Endpoint: "https://iconnect.nemours.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://app.nemours.org/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "New Hanover Regional Medical Center",
    Endpoint: "https://epicmobile.nhrmc.org/OAuth2-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.nhrmc.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "New Jersey Urology",
    Endpoint: "https://epicproxy.et1153.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.njurology.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "New York-Presbyterian",
    Endpoint:
      "https://epicproxy-pub.et1089.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.myconnectnyc.org/mychart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "NOMS Healthcare",
    Endpoint: "https://prdproxy.nomshealthcare.com/PRD-OAuth2/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.nomshealthcare.com/MyChart-Prod/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "North East Medical Services",
    Endpoint: "https://epicproxy.et1332.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.nems.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "North Memorial Health",
    Endpoint: "https://minerva.northmemorial.com/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.northmemorial.com/NorthMemorial/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "North Mississippi Health Services",
    Endpoint: "https://eiclbext.nmhs.net/interconnect-fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myconnection.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "North Oaks",
    Endpoint: "https://soapproxyprd.northoaks.org/nohsfhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.northoaks.org/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Northwest Community Hospital",
    Endpoint: "https://epicprdproxy.nch.org/prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.nch.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Northwestern Medicine",
    Endpoint: "https://nmepicproxy.nm.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mynm.nm.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Norton Healthcare",
    Endpoint: "https://epicsoap.nortonhealthcare.org/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.nortonhealthcare.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Novant Health",
    Endpoint:
      "https://epicproxy.et0798.epichosted.com/APIProxyPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.novantmychart.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "NYC Health + Hospitals",
    Endpoint: "https://epicproxypda.nychhc.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://epicmychart.nychhc.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "NYU Langone Medical Center",
    Endpoint: "https://epicfhir.nyumc.org/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://activation.nyulmc.org",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "OCHIN",
    Endpoint: "https://webprd.ochin.org/prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ochin.org/mychartchap/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Ochsner Health System",
    Endpoint: "https://myc.ochsner.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.ochsner.org/PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "OhioHealth",
    Endpoint:
      "https://ccpintconfg.ohiohealth.com/Interconnect-PRD-MUAPI/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ohiohealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Olmsted Medical Center",
    Endpoint: "https://epicproxy.et1077.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.olmmed.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "One Brooklyn Health System",
    Endpoint: "https://epicproxy.et0883.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.myonebrooklynhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "OptumCare East",
    Endpoint: "https://epicarr.optum.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://epicmychart.optum.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "OptumCare West",
    Endpoint: "https://epicpnwarr.optum.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://epicmychart.optum.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Oregon Health & Science University",
    Endpoint: "https://epicmobile.ohsu.edu/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychartweb.ohsu.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Orlando Health",
    Endpoint: "https://epicproxy.et1131.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.orlandohealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "OrthoCarolina",
    Endpoint: "https://epwebapps.orthocarolina.com/fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.orthocarolina.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "OrthoVirginia",
    Endpoint: "https://epicproxy.et1015.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.orthovirginia.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "OSF HealthCare",
    Endpoint: "https://ssproxy.osfhealthcare.org/fhir-proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.osfmychart.org/OSFMyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "OU Health",
    Endpoint: "https://epicproxy.et1181.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ouhealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Overlake Hospital Medical Center",
    Endpoint: "https://sfd.overlakehospital.org/FHIRproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.overlakehospital.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Owensboro Health",
    Endpoint: "https://fhir.omhs.org/rp-prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.omhs.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Pacific Dental Services",
    Endpoint: "https://epicproxy.et1079.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.smilegenerationmychart.com/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Palos Health",
    Endpoint: "https://nmepicproxy.nm.org/PalosFHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.paloshealth.com/MyChart/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Parkland",
    Endpoint: "https://pmh-vmhaiku-01.pmh.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.parklandhealth.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Parkview Health",
    Endpoint: "https://epicprod-mobile.parkview.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://parkviewhealth.medbridgego.com/access_token",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "PeaceHealth",
    Endpoint: "https://soapproxy.peacehealth.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.peacehealth.org/MyPeaceHealth/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Phelps Health",
    Endpoint: "https://epicproxy.et1134.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.phelpshealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Piedmont Healthcare",
    Endpoint: "https://webproxy.piedmont.org/ARR-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.piedmont.org/prd/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Pikeville Medical Center",
    Endpoint: "https://epicproxy.et1225.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.pikevillehospital.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Pine Rest Christian Mental Health Services",
    Endpoint: "https://wecare.pinerest.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.pinerest.org/mychartPRD/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Pine Springs Health Internal Medicine",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://pinesprings.epicmychart.com/psh/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Planned Parenthood",
    Endpoint: "https://epicproxy.et1154.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.plannedparenthood.org/planned-parenthood-south-atlantic/patients/mychart-patient-portal/mychart-signup-and-login",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Premier Health",
    Endpoint: "https://rx.premierhealthpartners.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.premierhealthpartners.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Premise Health",
    Endpoint: "https://epicproxy.et1052.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mypremisehealth.com/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Prime Healthcare",
    Endpoint: "https://phsfhir.primehealthcare.com/PHS-PRD-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.primehealthcare.com/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Prisma Health",
    Endpoint: "https://epicproxy.et0915.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.prismahealth.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "ProHealth Care",
    Endpoint: "https://soap.phci.org/Interconnect-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.prohealthcare.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "ProMedica Health System",
    Endpoint: "https://fhir.promedica.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.promedica.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Providence Health & Services - Alaska",
    Endpoint: "https://haikuak.providence.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychartor.providence.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Providence Health & Services - Oregon/California",
    Endpoint: "https://haikuor.providence.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychartor.providence.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Providence Health & Services - Washington/Montana",
    Endpoint: "https://haikuwa.providence.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychartor.providence.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "QuadMed",
    Endpoint: "https://epicicfore.quadmedical.com/fhirprd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.myquadmedical.com/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Reid Health",
    Endpoint: "https://epicproxy.et1220.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myreidhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Reliant Medical Group",
    Endpoint: "https://fhirprd.reliantmedicalgroup.org/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.reliantmedicalgroup.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Renown, Barton, CVMC",
    Endpoint: "https://fhir.renown.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.renown.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Ritual Medical",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://ritualmedical.com/new-patients/",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Riverside Health System (Newport News, VA)",
    Endpoint: "https://ep-rpfg.rivhs.com/Interconnect-FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.riversideonline.com/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Riverside Medical Center",
    Endpoint: "https://rpprod.riversidehealthcare.net/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://riversidemychart.org/MyChart-PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Riverside Medical Clinic",
    Endpoint: "https://sf1.rmcps.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://myhealthyconnection.riversidemedicalclinic.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Riverview Health",
    Endpoint: "https://epic-fhir.mercy.net/PRDFHIRSTL/RVH/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.riverview.org/app/registration",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Rochester Regional Health",
    Endpoint: "https://epicarr.rochesterregional.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mycare.rochesterregional.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Rush University Medical Center",
    Endpoint: "https://epicproxy.rush.edu/fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.rush.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "RWJBarnabas Health",
    Endpoint: "https://epicproxy.et1157.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.rwjbh.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Saint Francis Health System",
    Endpoint: "https://eprdsoap000.saintfrancis.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.saintfrancis.com/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Saint Francis Healthcare System (Manual)",
    Endpoint: "https://reverseproxy.sfmc.net/fhirproxyprd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.sfmc.net/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Saint Luke's Health System",
    Endpoint: "https://epicmobile.corp.saint-lukes.org/FHIRPROXY/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mysaintlukes.corp.saint-lukes.org/MyChartPRD/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Salem Health",
    Endpoint: "https://prd.salemhealth.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.salemhealth.org/mychart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Salinas Valley Memorial Healthcare Systems",
    Endpoint: "https://epicproxy.et1146.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.svmh.com/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Samaritan Health Services",
    Endpoint: "https://fhir.samhealth.org/fhir-arr/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.samhealth.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "San Francisco Department of Public Health",
    Endpoint: "https://epicproxy.et1082.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.sfdph.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "San Ysidro Health",
    Endpoint: "https://epicproxy.et1327.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.syhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Sanford Health",
    Endpoint: "https://eprescribe.sanfordhealth.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.mysanfordchart.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Sansum Clinic",
    Endpoint: "https://wavesurescripts.sansumclinic.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.sansumclinic.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Santa Clara Valley Medical Center Hospitals and Clinics",
    Endpoint: "https://scvhhsfhir.sccgov.org/interconnect-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://myhealthonline.sccgov.org/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "SBH Health System",
    Endpoint: "https://sbhepicrevprox.barnabas.network/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://sbhmychart.barnabas.network/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Scotland Health Care System",
    Endpoint:
      "https://epicproxy.et0905.epichosted.com/FHIRproxy/SCOTMYCHART/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.myscotlandhealth.org/myscotlandhealth/Authentication/Login?mode=stdfile&option=signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Scottish Rite for Children",
    Endpoint: "https://epicproxy.et0970.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.scottishriteforchildren.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Scripps Health",
    Endpoint: "https://haiku.scrippshealth.org/ARR-PRD-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myscripps.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Seattle Children's Hospital",
    Endpoint: "https://fhir.seattlechildrens.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.seattlechildrens.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Select Medical",
    Endpoint: "https://epicproxy.et0948.epichosted.com/FhirProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.selectmedical.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Self Regional Healthcare",
    Endpoint: "https://epicproxy.et1235.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.selfregional.org/MySRH/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Sentara Healthcare",
    Endpoint: "https://epicfhir.sentara.com/ARR-FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealth.sentara.com/account/sign-up",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Shannon Health",
    Endpoint: "https://epicrpx.shannonhealth.org/FHIR_ARR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.shannonhealth.org/mychart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Sharp HealthCare",
    Endpoint: "https://epicproxy.et1275.epichosted.com/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.sharp.com/app",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Shriners Children’s",
    Endpoint: "https://epicproxy.et1283.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.shrinerschildrens.org/MyChart/Authentication/Login",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Singing River Health System",
    Endpoint: "https://arr.mysrhs.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.mysrhs.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Skagit Regional Health",
    Endpoint: "https://epicproxy.et1005.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.skagitregionalhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "SolutionHealth",
    Endpoint: "https://epicproxyprd.solutionhealth.org/FHIR_PROD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.solutionhealth.org/MYCHARTPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "South Georgia Medical Center",
    Endpoint: "https://epicproxy.et1024.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.sgmc.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "South Shore Health System",
    Endpoint: "https://SSHIC.southshorehealth.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.southshorehealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Southcoast Health",
    Endpoint: "https://epicpproxy.southcoast.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.southcoast.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Southeast Health",
    Endpoint: "https://arrprd.southeasthealth.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.southeasthealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Southern Illinois Healthcare",
    Endpoint: "https://epicproxy.et0986.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.sih.net/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Sparrow Health System",
    Endpoint: "https://haiku.sparrow.org/fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.sparrow.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Spartanburg Regional Health Systems",
    Endpoint: "https://epicproxy.et0939.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.spartanburgregional.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Spectrum Health",
    Endpoint: "https://epicarr02.spectrumhealth.org/EpicFHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.spectrumhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Spectrum Health Lakeland",
    Endpoint: "https://fhir.lakelandregional.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.lakelandregional.org/mychartprd/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "SSM Health",
    Endpoint: "https://fhir.ssmhc.com/Fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ssmhc.com/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "St. Charles Health System",
    Endpoint: "https://epicproxy.et1030.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.stcharleshealthcare.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "St. Elizabeth Healthcare",
    Endpoint: "https://sehproxy.stelizabeth.com/arr-fhir/SEH/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.stelizabeth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "St. Joseph Hospital Health Center",
    Endpoint: "https://mobileproxy.sjhsyr.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.covh.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "St. Jude Children's Research Hospital",
    Endpoint: "https://rp.stjude.org/oauth2-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.stjude.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "St. Luke’s Health System (Idaho & Eastern Oregon)",
    Endpoint: "https://epmobile.slhs.org/Interconnect-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.slhs.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "St. Luke's Hospital (North Carolina)",
    Endpoint:
      "https://epicproxy.et0905.epichosted.com/FHIRproxy/STLUMYCHART/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.mystlukeschart.org/mystlukeschart/Authentication/Login?mode=stdfile&option=signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "St. Luke's University Health Network",
    Endpoint: "https://fhir.slhn.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.slhn.org/mychart/index",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Stanford Children's Health",
    Endpoint: "https://epicproxy.et0857.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.stanfordchildrens.org/Mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Stanford Health Care",
    Endpoint: "https://sfd.stanfordmed.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://stanfordhealthcare.org/for-patients-visitors/myhealth.html",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Stormont Vail Health",
    Endpoint: "https://epicsoap.stormontvail.org/FHIRproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.stormontvail.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Summa Health",
    Endpoint: "https://epicproxy.et1289.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.summahealth.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Summit Health",
    Endpoint: "https://epicsoap.bmctotalcare.com/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.bmctotalcare.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "SUNY Upstate Medical University",
    Endpoint: "https://epicedge.upstate.edu/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.upstate.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Sutter Health",
    Endpoint: "https://apiservices.sutterhealth.org/ifs/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealthonline.sutterhealth.org/MHO/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Tahoe Forest Health System",
    Endpoint: "https://epic-fhir.mercy.net/PRDFHIRAOK2/TAO/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.tfhd.com/app/registration",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Tampa General Hospital",
    Endpoint: "https://epicproxy.et0761.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.tgh.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Tanner Health System",
    Endpoint: "https://epicproxy.et1098.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.tannermychart.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "TempleHealth",
    Endpoint: "https://epicaccess.templehealth.org/FhirProxyPrd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.templehealth.org/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Texas Children's",
    Endpoint: "https://mobileapps.texaschildrens.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.texaschildrens.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Brooklyn Hospital Center",
    Endpoint: "https://epicproxy.et1043.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.tbh.org/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Center",
    Endpoint:
      "https://epicproxy.et4006.epichosted.com/FHIRProxyPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://thecenter.epicmychart.com/ctr/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Christ Hospital",
    Endpoint: "https://soapproxyprod.thechristhospital.com/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.thechristhospitalmychart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Everett Clinic",
    Endpoint: "https://fhir.myeverettclinic.com/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealthchart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Guthrie Clinic",
    Endpoint: "https://fhir.guthrie.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://e.guthrie.org/Mychart//signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Ohio State University Wexner Medical Center",
    Endpoint: "https://ihismufhir.osumc.edu/fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.osu.edu/osumc/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Portland Clinic",
    Endpoint: "https://tpc-shield.tpcllp.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.tpcllp.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Queen's Health Systems",
    Endpoint: "https://mobileapps.queens.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.queens.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The University of Texas Health Science Center at Houston",
    Endpoint: "https://epicproxy.et1178.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.myuthealthhouston.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The University of Texas MD Anderson Cancer Center",
    Endpoint: "https://fhir.mdanderson.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.mdanderson.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The University of Vermont Health Network",
    Endpoint: "https://epicproxy.uvmhealth.org/FHIR-ARR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uvmhealth.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "The Vancouver Clinic",
    Endpoint: "https://soapprod.tvc.org/ARR-FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.tvc.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "ThedaCare",
    Endpoint: "https://arr.thedacare.org/FHIR/TC/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.thedacare.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "TidalHealth",
    Endpoint: "https://eweb.peninsula.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.tidalhealth.org/MyChart/Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "TMC HealthCare",
    Endpoint: "https://fhir.tmcaz.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.tmcaz.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Tower Health",
    Endpoint: "https://epicsoap.readinghospital.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.mytowerhealth.org/mytowerhealth/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "TriHealth",
    Endpoint: "https://epicscripts.trihealth.com/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.trihealth.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Trinity Health",
    Endpoint: "https://epic-ext.trinity-health.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.trinity-health.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Trinity Health of New England",
    Endpoint: "https://epicprdext.stfranciscare.org/FhirProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mycare.stfranciscare.org/MyCare/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Trinity Health of New England Medical Group Springfield",
    Endpoint: "https://rmgpxy.riverbendmedical.com/fhir_proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.trinity-health.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Tufts Medicine",
    Endpoint: "https://intconfg-p.well-net.org/PRD-OAUTH2/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart-p.well-net.org/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UC Davis",
    Endpoint: "https://emrrp.ucdmc.ucdavis.edu/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.ucdavis.edu/MyChart/Authentication/Login?mode=stdfile&option=Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UC Davis - MMC",
    Endpoint: "https://emrrp.ucdmc.ucdavis.edu/FHIR/MMC/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.ucdavis.edu/MyChart/Authentication/Login?mode=stdfile&option=Signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UC Health",
    Endpoint: "https://epic-soap.uchealth.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.uchealth.com/myuchealth/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UChicago Medicine",
    Endpoint:
      "https://interconapps.uchospitals.edu/PRD-FHIR-Proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uchospitals.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UCLA Medical Center",
    Endpoint: "https://arrprox.mednet.ucla.edu/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.uclahealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UConn Health",
    Endpoint: "https://epicproxy.et0996.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uconn.edu/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UCSF Benioff Children's Hospital",
    Endpoint: "https://unified-api.ucsf.edu/clinical/apex/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.ucsfhealth.org/mychart",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UCSF Health",
    Endpoint: "https://unified-api.ucsf.edu/clinical/apex/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.ucsfhealth.org/mychart",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UF Health",
    Endpoint: "https://epicsoap.shands.ufl.edu/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.shands.org/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UHS San Antonio",
    Endpoint: "https://epicproxy.et1130.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.universityhealthsystem.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UI Health",
    Endpoint: "https://epicproxy.et1085.epichosted.com/FHIRPROXY/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uillinois.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UK HealthCare",
    Endpoint:
      "https://ukepicproxy.mc.uky.edu/Interconnect-PRD-OAuth2/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uky.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UMass Memorial Health Care",
    Endpoint: "https://epicproxy.et0978.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychartonline.umassmemorial.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UMC Southern Nevada",
    Endpoint: "https://epicproxy.et1023.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://umconnect.umcsn.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UNC Health Care",
    Endpoint: "https://epicfe.unch.unc.edu/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.myuncchart.org/mychart/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "United Health Services New York (NYUHS)",
    Endpoint: "https://epicproxy.et1127.epichosted.com/FHIRproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.nyuhs.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "United Regional Health Care System",
    Endpoint: "https://epicproxy.et1096.epichosted.com/FHIRProxy/api/fhir/r4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.unitedregional.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UnityPoint Health",
    Endpoint: "https://epicfhir.unitypoint.org/ProdFHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.chart.myunitypoint.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University Hospitals Cleveland",
    Endpoint: "https://uhhsportal.uhhospitals.org/oauth2-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uhhospitals.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Arkansas for Medical Sciences",
    Endpoint: "https://ucsoap.uams.edu/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uamshealth.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of California Irvine",
    Endpoint: "https://epicproxy.et0502.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.ucihealth.org/UCI/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of California San Diego",
    Endpoint: "https://epicproxy.et0502.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ucsd.edu/UCSD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Colorado Health",
    Endpoint: "https://ss.uch.edu/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.uchealth.org/access-my-health-connection/",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Iowa Health Care",
    Endpoint: "https://myepicapps.uihealthcare.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uihealthcare.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Kansas Health System",
    Endpoint:
      "https://fhir.kansashealthsystem.com/interconnect-PRD_FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.kansashealthsystem.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Louisville Physicians",
    Endpoint: "https://epicproxy.et1193.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uoflhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Maryland Medical System",
    Endpoint: "https://fhir.umm.edu/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myportfolio.umm.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Miami (UHealth)",
    Endpoint: "https://uhealthsoap.med.miami.edu/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myuhealthchart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Mississippi Medical Center",
    Endpoint: "https://soapproxy.umc.edu/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://www.umc.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Pittsburgh Medical Center (UPMC)",
    Endpoint: "https://epic-fhir-prd.upmc.com/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://upmccentralpaportal.com/mychart/Authentication/Login",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Rochester Medical Center",
    Endpoint: "https://ercd-sproxy.urmc.rochester.edu/MIPS/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.urmc.rochester.edu/mychart/home.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Texas Medical Branch",
    Endpoint: "https://epic-arr.utmb.edu/fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.utmb.edu/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Texas Southwestern Medical Center",
    Endpoint: "https://EpicIntprxyPRD.swmed.edu/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.utsouthwestern.edu/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Toledo",
    Endpoint: "https://icon.utoledo.edu/ic-oa2-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.utoledo.edu/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "University of Utah Healthcare",
    Endpoint: "https://webproxyprd.med.utah.edu/FHIRMyChart/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.med.utah.edu/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UPMC Central PA",
    Endpoint: "https://Epic-Arr.pinnaclehealth.org/PRD-FHIR-ARR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://upmccentralpaportal.com/mychart/Authentication/Login",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UT Health San Antonio",
    Endpoint: "https://epicproxy.et0582.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.utmedicinesa.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UVA Health System",
    Endpoint: "https://hscsesoap.hscs.virginia.edu/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.healthsystem.virginia.edu/Mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UW Health And Affiliates - Wisconsin",
    Endpoint: "https://epicproxy.hosp.wisc.edu/FhirProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.uwhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "UW Medicine (Washington)",
    Endpoint:
      "https://fhir.epic.medical.washington.edu/FHIR-Proxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.uwmedicine.org/prod01/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Valley Children's Healthcare",
    Endpoint: "https://ic.valleychildrens.org/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://www.valleychildrens.org/about-us/mychart-patient-portal",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Valley Health System (VA)",
    Endpoint: "https://epicproxy.et1320.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.valleyhealth.org/PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Valley Health Systems",
    Endpoint: "https://api.valleyhealth.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.valleyhealth.org/PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Valley Medical Center",
    Endpoint: "https://FHIR.valleymed.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.valleymed.org/MyChart_PRD/Authentication/Login",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Valleywise Health",
    Endpoint: "https://esoap.mihs.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.valleywisehealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Vanderbilt",
    Endpoint: "https://arr01.service.vumc.org/FHIR-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://myhealthatvanderbilt.com/Authentication/Login?",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "VCU Health",
    Endpoint: "https://epicproxy.et1200.epichosted.com/OAuth2-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.vcuhealth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Vidant Health",
    Endpoint: "https://prd-proxy.vidanthealth.com/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.vidanthealth.com/mychart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Virginia Hospital Center",
    Endpoint: "https://common.virginiahospitalcenter.com/FHIRPRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://myvhc.virginiahospitalcenter.com/MyChartPRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Virginia Mason Franciscan Health",
    Endpoint: "https://rp.catholichealth.net/fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.catholichealth.net/PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Virtua Health",
    Endpoint: "https://epicproxy.et1017.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://secure.myvirtua.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Waco Family Medicine (Heart of Texas Community Health Center)",
    Endpoint: "https://haiku.wacofhc.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.wacofhc.org/mychartwacoprod/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "WakeMed Health and Hospitals",
    Endpoint: "https://epic-soap.wakemed.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.wakemed.org/MyChart-PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Washington Hospital Healthcare System",
    Endpoint: "https://psacesoap.whhs.com/interconnect-fhir-prd/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.whhs.com/MyChart/Authentication/Login",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Watson Clinic",
    Endpoint: "https://epic-arr.watsonclinicad.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.watsonclinic.com/PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Weill Cornell Medicine",
    Endpoint:
      "https://epicproxy-pub.et1089.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL":
      "https://mychart.weill.cornell.edu/mychart/Authentication/Login",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "WellSpan Health",
    Endpoint:
      "https://interconnect.wellspan.org/interconnect-prd-fhir/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://my.wellspan.org/MyWellSpan/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "WellStar",
    Endpoint: "https://epicsoap.wellstar.org/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.wellstar.org/MyChart/signup",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "West Bend Family Medicine",
    Endpoint: "https://epicproxy.et4001.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://westbend.epicmychart.com/wbfm/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "West Tennessee Healthcare",
    Endpoint: "https://epicproxy.et1243.epichosted.com/OAuth2-PRD/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.wth.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "West Virginia University Medicine",
    Endpoint: "https://apps.mywvuchart.com/fhirproxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mywvuchart.com/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Western Michigan University School of Medicine",
    Endpoint: "https://hygieia.bronsonhg.org/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.wmed.edu/MyChartWMED/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Woman's",
    Endpoint: "https://epicproxy.et1339.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.womans.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Yakima Valley Farm Workers Clinic",
    Endpoint: "https://epicproxy.et0943.epichosted.com/FHIRProxy/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.yvfwc.org/MyChart/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Yale New Haven Health System",
    Endpoint: "https://patientfhirapis.ynhh.org/pff/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mychart.ynhhs.org/MyChart-PRD/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
  {
    Hospital: "Yuma Regional Medical Center",
    Endpoint: "https://yrmccare1.yumaregional.org/FHIR/api/FHIR/R4/",
    "Endpoint Access Issue": "",
    "Sign-up URL": "https://mycare.yumaregional.org/MyCare/accesscheck.asp",
    "Online Sign-up Access Issue": "",
    "Include in Platform": "YES",
    platform: "Epic",
  },
];
const cernerOrgListR4 = [
  {
    Hospital: "Oscar Matthews, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/-KzIoYV6gk-ILcHOWbsH2m9KsSdDgi12/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Vishen, R K MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/-MIuTZfWACgngV9YTgKmhcl1PVL8iu53/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Treasure Coast Podiatry",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/-c6Xwd-UlrvkHnaNj_A8a39Pa03efHEX/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Alaska Native Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/-yJKGL5-49LdGDJaxmfdb85K2Njr-hkB/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Leidos Partnership for Defense Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/00224df3-b096-4cdb-852c-cbc83c0d3b06/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Encompass Health Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/00a074df-768e-479f-9c8c-52c5c5bbe010/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Earl Jacobson, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/00a934e0-7e93-4023-8ce4-79bbebc496ce/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "CarolinaEast Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/00bf2f08-38fe-4c4c-8207-96dbe42a9302/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fredonia Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0153994b-73fd-40ca-acc3-d43bb5781a7b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hancock County Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0187d1c0-26b8-42cb-81e4-84d2429978e8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Smoky Mountain Foot Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/01b09d82-4514-482c-85d3-2d53721811fb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Chicago Wellness Center Coalition",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/01e186a8-87ec-4e25-bc02-8b7eb7d8fa78/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Atlantic Medical Associates, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/01f94e02-09c3-48f8-b3d5-d9516d905113/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "J.E. Dunn Construction Co.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/02a7a8bc-d7be-4d03-9c99-4404e94deb88/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blair Foot & Ankle",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/02cf5ef5-9abb-4937-8933-e06c47e975a4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Primary Care Specialists, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/036f7da9-ca9c-4c26-bc90-ad8f4c7667ec/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Valentenia Daugherty and Alvin R. Smith, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/038d560d-2426-45c9-9ab5-03b271fcacb7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr Pepper Snapple Group - Irving",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/039c5844-07d3-4b98-88f9-0db4fea884ad/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Midwest Surgical Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0434cb5f-f658-4821-a9c3-c13cf287f39b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Suganthini Umakanthan, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/045b627f-46d4-4a3f-ac6b-f056b251cd0e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Baraga County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/045c8928-6944-45ab-848b-c64a6a14eb07/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "State of New Mexico",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/04b7d73f-0769-4509-8cd9-c3061dc75979/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jefferson Psychiatric Associates, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/05a97b88-f719-405f-abbb-125ac71b7cee/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Healthe Employer Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0635029c-ad2b-4c76-90de-10b216b6fefa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Montgomery County Pulmonary & Sleep Consultants, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/065b8b09-4f7d-467b-8952-a1ff3f821682/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Podiatry Associates of Lake County",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0699f5e4-11ef-4cab-a1a5-a9d1e45fecf3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Palo Alto County Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/06ad70d1-0ea3-42fa-b01a-c8e7e524255d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nicholas S. Guittari, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/06f3e7b9-e238-4c7d-9b45-146676e73d3c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "VCU Health System Authority",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/072ee25e-9ba2-4626-bd4b-17ff1ccdc763/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Specialists in Spine Surgery",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0748ed02-a595-4783-955c-c255cede53e3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gavy MD CSP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/07816ee1-ddda-45ce-ac7b-e8d3ee5f4c74/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Charleston Area Medical Center, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0857bd9d-3fb8-4b0a-9180-f75d160828c9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Masonicare Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0902817a-ed68-43fa-954a-bea5acd79d50/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Old Naples Concierge Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0923cfa9-b935-457b-863a-3708d0944463/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Luke's Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/09c6832d-8ba2-41f5-8eee-a1da45053f6c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Warren E. Kaplan, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/09ea3bf2-1790-4a4b-8cf3-6344789bb530/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Srinivasa Rao Movva",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0a308bb2-a313-4473-991c-9bf6e3578c55/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Heart & Vascular Specialists of South Texas",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0aa75aff-7eca-4255-be9e-a914bffb6f20/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Manuel Lovo",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0abea9c0-1e9f-4430-ab68-c2420de4e9fb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blanchard Valley Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0affe579-9d95-4ec1-b178-1df7328cc0a1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Minneapolis Walk-in Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0b25ce83-fe52-4222-8ff2-02c9187687e9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sharon Regional Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0c45d456-c156-4baa-b6a0-bf60418740f7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Peoples Bank",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0c998443-0f2a-46b6-b9e7-8ed07cb41745/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Adventist Health Delano",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0ca83d5d-e2a2-460f-9fe7-e5dfa535cbb3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UPMC Children's Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0d020f94-2b1e-4cb2-a9d2-eecf3a1a0504/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Associates In Anesthesia",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0d26bd04-9128-4f58-8e6d-ffda5cd00f89/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Margaret Mary Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0d93d980-a159-4c3e-9a19-131175682196/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jeffrey Lubell, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0dd23348-ab65-4cd7-899a-47a7e7f6edaf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Central Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0e14dd7a-54b5-4e15-8bd7-0053cd69b1ac/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Seiff Center for Aesthetic and Reconstructive Surgery",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0f01f77a-8c85-47f1-aaa5-2b7968c0806e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mercy Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0f28b1ab-8e47-4a25-b8ea-aeb6ede39b7d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lake Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0febeb13-8e64-489b-8219-6b0ac5c29683/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "DrumHill Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0gHAygDLIJOak6hn-5BrJ04gaSGnHqqo/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dignity Health CAREB",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0qElfuk7cvLgJndB7hTiCVck6NR0D5uM/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gabbie Medical Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0vrdpNH7rwpdKHXHV32pI9kiii8_MVX2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Jude Children's Research Hospital, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0vyEi96gIReUeVY9zVUR_9P93k0t7cHR/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Medical Clinic of Red Bay",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0w2X68WoJybtavj9KNOUNqH4zjiuzU9x/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Associates In Women's Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0xaf05FmjZ-fj0mKwlDaatWN5u2rBjbF/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "San Joaquin General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1014839d-07f9-4c12-a617-3f1d8afea267/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Chinese Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/101c0869-4f3e-4fdb-af79-02ba9f712e30/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Indiana Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1031a3cd-9903-4995-baa5-734895a3e2a2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kathryn Amacher, D.O.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/10521376-f6e6-41c2-a307-0de4e8ac5c2b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cullman Medical & Pediatric Assoc. PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/10SsEyRV6mB-ixPURUQbSLUZ7vtegZBi/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "McKnight Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/110cb3c6-b110-474f-9f37-1dc02438d0c6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cardiology Associates Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/11bc0c3c-c195-42b2-ba3e-5064c5f00185/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jerome A. Cohn, DPM PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/11c92883-3ba8-4054-8136-467108df0876/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dinesh Lahoti, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/11c9f394-ec26-4c20-ab5b-88e040706ab4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UAB Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/11e960ca-465e-403d-a8ac-dfa9be65dd83/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Silver Cross Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/11ea0cbd-06f9-4ba7-9e47-64230780fa06/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hidenao Kimura, MD, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/11ec782a-a256-41d9-a180-ba3424536d6e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "G. Perrin Underwood, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/12a1c355-c61a-45a8-a04e-bf576ee7490b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Surgery Partners - Nashville",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/12e6e189-04bb-431f-917c-32d5c1bc83d5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Kostecke",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1343d08e-d344-4cf3-8b4c-00d3bf2d2f22/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "William Defeo, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/135a9a14-5851-4db5-b6e4-bd9037eef316/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "LifeBridge Health, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/136fea15-c667-40bc-9ed2-b1115d62123b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Beebe Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/13b50b3e-3008-4cea-8436-d50ebe0744e1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "George L. Thaler, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/13e0424e-cf2d-4fa1-8eeb-46000e113cfb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Anderson Dermatology and Skin Surgery",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/14194f57-1cf1-4d77-801e-4659b5b99d4c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Asheville Podiatry Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1426d78c-0f62-4721-863e-5a04f771d495/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Physician In-Home Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1489851f-6448-4afb-9a0e-12d9d94aa987/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Atlanta Rehabilitation Physicians, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/148d0862-3261-4a44-ba2d-29293ff91161/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Poarch Band of Creek Indians",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/148f5931-d9cf-4d65-8c66-7021ed161b73/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "New Jersey Cardiology Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1593d2dd-b3c3-4c3f-8320-e8d38b879416/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "ENT & Allergy Associates, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/15dd2bda-9d00-4c3d-967c-f374acf8d6ab/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Capital Region Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/16386a34-20a6-42d6-bf13-226b287a42a5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bellville Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/16a6a2d0-9070-4585-9404-d87e500b89cb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Shore Cardiac Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/171160fb-ff0b-4d2a-a719-19590b4d5214/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "California Correctional Health Care Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/171973c1-c2f6-42fa-96ac-2222224c476e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hamilton Health Care System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/175c9c17-1687-46b3-a9fa-8603ef5296b5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jaime E. Campos, MD, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/177ce732-146d-43d6-b1f2-f27ab10b5dfe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Alamo Psychiatric Care PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1845df8d-054c-4f01-87bb-96587b55c793/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southdale Pediatrics Assoc., Ltd.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1846cf9e-8006-4277-b72f-3cbbe8a8f5ca/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dustin Hubbard, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/18845894-5a9c-4f61-b462-cea2ada953b3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "GC USA of Florida, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/188a9934-272e-40a6-b77d-07674ebcbb4e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Children's Hospital Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/18c2ddf7-cb55-4622-a2b3-eb9aad8f5a43/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Urology Partners of North Texas, PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/18f5d65c-83f0-435a-868c-70ce5a6de90a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Magruder Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/19553296-f85a-48c6-9c93-313791e9f18b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Robert S. Stipek, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1AN2znHfTFaFUc4YPucjdabPqWM4Ifu6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "David L. Crowder, M.D., Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1Dszw2goTz-HRPQAjnp5h-SWxEe2-Tfi/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gillette Children's Specialty Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1a27c25c-f98c-457f-a68f-46b79305bda6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Michael A. Marvin, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1a2e2e0d-8e43-4f2f-8b9e-bbbe114275a3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Professional OB/GYN Doctors",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1aaa2297-cd97-4f91-84aa-bfa4adb4e672/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "W. David Mello, M.D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1ac545fd-ef52-46ef-9d44-79bace12a10b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Eugene Shteerman, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1acb1d90-1c8d-4447-b242-48d6b194317b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Renal-Hypertension Clinic, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1ad2a81d-d102-4f59-a87a-db4fa01056bd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mountain Grove Health Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1b1e5c61-56d7-451b-9b71-92a7bd3e453e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Bose Industrial & Family Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1b2b742f-42bf-43a5-8c28-95e9ccd18862/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tallahassee Podiatry Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1b51b01a-cf35-4022-974c-7633d8b348f9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Metro Infectious Disease Consultants",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1b768eee-dd17-4e01-8b1e-f5330ffd0ffa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Little Colorado Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1b77ef85-4263-4810-a991-372a36dc4ff0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pediatric Associates, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1ba56762-29f3-48fc-ab7a-bea5f733932b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Personalized Primary Care Atlanta",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1bd57171-f0fc-42ae-9baf-e255a76f2819/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Liberty Dayton Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1c4e6005-70c8-4848-94e1-292ffa50fed2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hemphill County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1c565283-08b7-4811-af3a-d8ab0c3d5260/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northland Health Care Access",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1c9815c7-2fbe-40be-9813-e5639c105f69/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Florida Pediatric Partners",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1c9cb0c5-1db1-401e-9a06-132d030c72c2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ascension Providence Rochester Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1co7TB-AnE4kKYvBDzXBJf-MlYrYrEnf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Texas Tech University Health Sciences Center at El Paso",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1d0193b5-c6df-4894-ba58-5a49f2d64f8f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kane County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1d0400a3-4b8b-4837-b984-e3261fda469a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Indianapolis Gastroenterology, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1d5dc169-f536-4ee1-9c67-c93c23521729/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Raso and Cohen Gastroenterology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1d6c3167-ceed-47b0-b6f7-156a9cb2ffbe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neurology & Sleep Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1d6c927a-8fe8-4114-911c-8498e2eb642e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Merrimack Valley Orthopaedic Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1e6e321c-be51-4a82-a0ac-c7ba981fee78/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Heritage Medical Associates, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1e751165-d0f5-47ed-aa9b-1a8abb55d1d6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Emory Healthcare Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1ea8551e-0fb1-4703-8c98-94d25868feac/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Goldsboro Podiatry",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1ee7fa8c-2604-4e16-b1f2-79febf0fab94/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Iredell Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1faf3cea-e504-4363-85be-017534ea9e27/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "City of Asheville Health Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1fc28530-8f60-48e4-aea0-77fe08e0b8d3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "G. Scot Johnson MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1iSUCOMo-1LnA2beSKjvOuwrZcTnFbq7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Tilak Mallik",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1pr65N3sygbkRcFn_c89F-donYqb1-Dt/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cullman Surgical Assoc., P. C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2017165a-e6da-4297-96d2-0da8973a33da/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "James Rommer, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/20233ef0-1a16-48bd-a934-aa148473a80d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "New Coast Cardiology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/204a45c4-fa47-4c88-b6c6-15100f41107e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tallahassee Memorial HealthCare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/20840a0f-84f0-4541-a74c-e4481222809f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Los Angeles County - Dept. of Health Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/208486af-ceea-4a7d-b4d7-95c884a327df/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kidz Medical Services - Miami",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2088f28f-3c6b-4771-b216-22a921e823e3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "BioMerieux- U.S.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/20a3a78c-c5c6-45f6-a1b4-84caff15a9cb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Women's Medical Center of Meridian",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/20d7d246-549d-436f-88f7-e8d24a8a542b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Drs. West, Scharf, Conte and Bastianelli",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/20f47704-6d52-45dd-af98-57014a72c180/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Stewart, John A., MD, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/22Uc-fJDB9OVJIDI_oIBMMN7nEcPcLZt/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "M.E.N.D., PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/22d22c3c-8384-4172-b58d-229dd78c4154/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Trego County-Lemke Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/235ba15f-6bef-42d8-831c-5f3f60c7755f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lafayette General Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/236f7d43-7a42-43a2-8ab2-2a433cf5cb41/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nicholas S. Vachon, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/237aa410-7cb8-4ac1-ba42-3944408d6c7f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cleveland Family Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/237d7594-4541-4b90-ad67-9467f72ad1ef/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kittitas Valley Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/23941371-53b3-4b40-a249-d9e5af645869/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "General John J. Pershing Memorial Hospital Association DBA Pershing Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/23d7eb1d-294f-4546-883b-c856fcd53f34/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Scott A. Groat, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2473c3e4-a3db-44eb-852b-6c845f6e5961/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Precision Surgical Specialists of Lowell",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/248c4eac-ef54-410c-af1d-d3a135ccb339/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "TidalHealth",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/24a392d6-e8f4-4f4c-9344-2c748653164b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Van Diest Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/24c3ea72-6b18-4192-9262-677c412fb10a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Paul Potach D.P.M",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/25323118-f910-447e-97a3-efa84a07950e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Joel L. Gellen, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/25641f20-a69b-41d6-9c60-3287d9431b57/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Toyota Industrial Equipment",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/256e21d7-83b6-43a8-a945-8a46e496b3df/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Central Valley Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/26081706-bf97-4a1b-96e4-2d82c3343f85/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Walnut Lake Ob/Gyn",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/26519c41-5760-4666-aec7-131cba00ac7b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AdventHealth Ottawa",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2706bae0-904c-4f4d-a308-d6dab1fc6e73/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Colorado Canyons Hospital & Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2727d563-1937-4182-91c8-c6faf5efe876/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Allergy & Asthma Clinic of Alexandria",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/27425bf5-b70f-4e57-a4e7-5af1c20e4949/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Edward L. Murray, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/274f233e-d0c5-4660-bb64-e2ff085087aa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Caritas Clinics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/282ac7c4-9db7-44ff-9e15-9477722bfca6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Beacon Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/28FMw_aQtzSqkrYbQSc2Fss9Rc_nhEOH/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Adventist Health - Corporate Office",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/29a5ccea-f4ab-4447-a191-56b20695970f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mid-Nassau Medical Care for Kidz LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2QFBP_GpXSU7KIclk_f76cqIGbQoW5zf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2RN95TVx9sVNwZUXvBjAMhoPj5vjnRtA/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Mary's Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2a03f846-9bbb-4db8-982b-8f866f480435/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Methodist Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2ae7d625-833b-4a4d-a216-8fc7be3f9894/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Allen A. Flood, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2b2a3443-b072-4bef-8852-df9682c77c5c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Evolution Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2b4ecf8d-3f0b-405c-8db8-17bbbe95252b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Vail Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2b53e1a6-a4f0-4eb4-9db6-d7bb72f1c188/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Saint Thomas Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2b718c34-d07f-43cc-9f41-df1abcd82912/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gibson County Podiatry",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2bc71e38-c7fb-4443-b9ec-1941e90edee2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. William Strazzella DO",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2c050f9f-35c2-457e-bf0d-830a643051e4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Burrell Podiatry Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2c42bde2-96fc-4b1a-a5b7-e9138619239c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Foot Care Group, PC.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2c834eee-5231-4dd1-ba8d-28931b99c0cc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Central Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2c98a2ec-4d1e-465a-85ea-978418d9b03d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Warren J. Degatur Jr. MD, FAAFP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2cb3d6db-a361-49b3-a3c3-68fe3216159f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Foot And Ankle Associates of Maine, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2ccb01ad-4a64-4074-9560-d61ce84ce4ce/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Eye Specialists",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2cde80e5-c678-4804-afb2-5ad93811f383/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cherokee Nation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2d405cde-1d8b-4a50-adff-ca7776cd856e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Donald Huang",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2da544c8-ef40-4e26-86e5-29350376d197/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jewell County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2daa157e-8b5f-4b5c-b571-5b57834b9765/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "First Choice Community Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2e044b81-e4a1-4dfe-8ce3-5d982e938db0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Martin County Hospital District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2e0b373c-6849-4975-9202-a3b4d9fb20f3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Prisma Health-Midlands",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2eNdqWco_jtc-pQyC1ajFurJasuKSupq/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Digestive Disease Consultants",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2ed1c574-c5ac-427e-a2ed-e9f8b5471f70/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Vascular Surgery Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2eeadd18-0e47-46b5-b124-bf3110ed368e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Oncology Associates, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2ef7a227-7c5f-434c-8ef1-c7b04bd0431e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "College Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2f200361-7791-4302-badd-31bba76d31ab/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "American Fork Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2f242d85-274e-4e3f-a641-44b7b63bac25/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Institute of Neurology and Neurosurgery at St. Barnabas",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2f26dc99-c358-4b2b-a63e-0bdfec0a9b98/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Boone County Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2f32da6e-80b8-497f-843c-a19a93e136d5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UHS_Ambulatory_West",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2f4f2c9e-c9c5-48b1-95a2-1ba6a49a76fd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "EvergreenHealth",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2f5abe1a-075b-4780-9a6d-abc160cae936/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Arlington Podiatry",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2fc0a311-4308-49e6-8f80-b20728e79c72/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Prospect Medical Holdings  - Waterbury Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2ff937d5-49c0-4d88-b923-0f5bdcf3b04f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kathryn L. Ford Family Practice Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/30290204-0354-41d4-82d0-b5e3a0bc4ec5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gerald Champion Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/304d13bb-2c34-4ffe-bf3e-d4d17562b002/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neshoba County General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/30747ffd-8a27-4deb-952a-ce2992dc36bd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Stafford District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/30cec37b-518a-4b38-8069-430360af95cf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "San Juan Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/30ec54bc-d6f1-41e4-8f29-88104e9b8ee6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Premier OB/GYN",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/31c1d82c-d665-40a0-b8bd-9d7f82d8d52b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dover Cardiology Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/31d30d44-6840-4141-93e1-b13c2f0041c7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mission Health System, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/31d3d17c-a50c-4d78-bc5b-e9716826315e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dignity Health Yavapai Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/325e1759-f94c-41b9-87e4-ef568789898b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "New York Comprehensive Care P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/329afbd4-f1aa-4709-b672-086217c311d9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Foot & Ankle Center of SJ",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/32e03c95-b309-4594-826f-8331ad619414/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Joseph W Strangarity, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3337e6ed-5252-430d-9683-b149b59b10c0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rush Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/333e9bbc-c795-477c-b297-aba3ff88fb23/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Instituto Medical San Nicolas (IMSAN)",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/33781e48-45d8-4dd5-8e8e-25f1504575df/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Billings Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/339d960e-9d8d-4e91-ba79-ed2766dd88b4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Philadelphia Academic Health System, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/33e49b5e-dbf0-4f99-9e36-7dc90fb7b97f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Columbus Regional Healthcare System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/343172e7-a805-41c0-9b12-57213fdd82cd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Stephen Vile, M. D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/349347bc-b57a-40bd-9d6e-a0d5831d7c75/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Vincent Reyes",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3496639b-bf45-42dc-8e9b-e1a123f14b1a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "New England Foot & Ankle PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/34UBEiA4BbjrlyKzOs77LsHNvAbVl0ub/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Veronica Kacmar-Fedorchak, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/34c7ad52-72ac-4308-ba34-6fd734dc9209/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Boyle Heights Nephrology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/34e9cf55-d4f0-4e9c-8676-4a0b3dc4bae0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Crisp Regional Hospital, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/34ff5e8d-9e6e-46ac-96bc-b559872b0325/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "James T. Cort Internal Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/35e4307a-9a7e-4250-8069-e6f294ff562b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gothenburg Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3674500c-a3e1-42b1-b8ad-0a387ebf7b32/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lowell Surgical Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/36adad9c-8758-4091-9c08-d4e8de999cfb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Neal Suares",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/36e35b4b-e4c5-4e91-9408-cf0fec2fda80/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southwest Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/370a27ae-e433-405a-8270-a345a875a69f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Minneola District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/37f6d032-7bca-45b8-891c-69b79d7f4de8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nevada Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3813b615-6514-44ac-92c9-256417b57cd1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kevin R. Henry, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/38b800d7-d14c-4f4e-8156-bce045188911/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Israel Alvarez",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/39daffa1-6093-4b32-b0bb-17d705a8f06d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cabell Huntington Hospital, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3N1pCmlUG0710nvlzCuO977VaU0tztwr/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Raritan Family Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3a1dfc54-3ef1-4d24-a87c-45de2dcda2e0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Atlanta Ropheka Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3a26afd9-920c-4709-8b6b-367ca80f62e3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Decatur County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3a35c68f-f24b-40b5-8425-cac7e4d992c3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sepulveda & Associates, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3a5f2b67-21a2-4bcc-959e-bdff6da685ae/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Stonewall Jackson Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3af1289d-eb50-43a1-88d7-f9212538b9d6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "M. Edwin Davis, M.D., P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3b1ec0f9-269d-4e41-99b2-594fce574943/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Belkys Bravo, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3b364ba7-1e24-4e24-b187-fb3fc86431d8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Medical Clinic of Northville PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3bd112f2-a293-4bc2-86f3-8aca32fd3911/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "RWJBarnabas Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3c2e5608-7636-4d74-9aae-b044a991c609/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Covenant Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3c4a889f-c0c4-4f50-90d1-60f6a5ad9e7d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Shriners Hospitals for Children",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3c7d34e4-f6df-45bc-8b63-906233176adc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Niagara Falls Memorial Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3c975af8-28ae-4d97-adec-66228015b5a8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "West Alabama Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3d32fa57-0589-4d21-9742-97970793cb6a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Doctors For Senior Health PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3d9dbe31-b367-4223-9466-3a189a9f7ec9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "San Francisco Foot & Ankle Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3dd204c7-56e5-4b85-94ad-73d0aa33f7f3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "SB Clinical Network IPA, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3deed0a2-b4ed-4322-bda6-41cde7bf5418/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Douglas A. Taylor, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3e04b313-762b-4964-b3d9-80f2559aa94e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "OSF Saint Clare Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3e12b969-e9cf-4559-9980-aa408e074b16/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AtlantiCare Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3e8d4a4e-e1e9-4f4d-8b87-af7fa09f6ac8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Billings Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3fc2ee37-7a41-4403-8e60-b36e163e05df/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Luis F. Soto,LLC.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3fe0dd43-a33d-4fd4-a49d-ab2fa460e893/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Doctors Hospital at Renaissance",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3fe59471-3589-4f65-b447-b92822bfc057/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Medsouth Associates, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3iBzJkAlx2Dh_gbW0DPrMPITOG-k7xrK/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Foot & Leg Specialty Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3jN56CzgE42qN67V-IipLF6k9nZSJJYD/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Associated Nephrology Consultants",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3y297hHso-SAgtaVMIScpv67gSH7SYy3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lexington Cardiology Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/401be0da-78bd-4f38-816f-7ed627bf5b4c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Digestive Disease Consultants",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/415f73c4-eb26-4a2f-bd48-682d90f715e0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Colon & Rectal Surgery Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4186e40c-ae1e-4c84-b5ea-1707df8e59de/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neurology LLP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/41c6ed25-3515-4b65-ae90-1ce32a76404d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Monongalia County General Hospital Company",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/41e7ed61-011a-4b3f-8e27-7aa832467b04/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Great River Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/42531be2-cc81-4ca4-b6c8-9b0ab56190c5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "HHP Internal Medicine Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4286a155-8d38-4f8a-8d99-037dcb62ebaa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hudson Physicians, S.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/42a1ed53-a9ac-42b2-918f-be592f726951/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "American Anesthesiology of NJ",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/430a7ff7-9999-4cda-a19f-fb8b573704c8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Katherine Shaw Bethea Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/43b952fe-d2a5-473b-b04a-92c422b758a3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Caddo Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/440a8ebc-db01-474a-8d18-2ca626c92c6c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gary L. Adsit, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/443f9f6a-5b23-4b72-82a6-952cfef57015/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ellis Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/44449a6c-e014-4a84-b9a2-5f63676d31de/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Seattle Children's Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/449052b2-b4e6-4960-bed6-39119385345b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Internal Medicine Physicians PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4492e985-44bf-43dd-a2f3-262f81a54d5c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kadin Foot & Ankle Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/44ca39cf-2a83-44a1-9f1c-726bd1023e23/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "McLeod Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4505c6b8-b247-4d01-9a89-0b566587111a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Central Maine Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4517c430-03bf-4e32-b324-1387cc4e73f3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Heidi Brewer, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/45fd479e-4bcb-44bd-af7f-1d81650d7682/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Boca Raton Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4680ff74-0924-406e-b918-8a3dc5ea07ee/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "New Richmond Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/469198d4-e8c3-4208-8246-4a46a3b54553/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Advocate Sherman Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4721098a-ef23-4d42-a063-77f2353a0d59/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gastroenterology Center- MS",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/47494c44-199d-4eaa-a659-6335d3720af2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University of Tennessee Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/479d1758-f967-4c2c-8306-7960101dd8ca/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "City Wide Medical",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/482289d0-2f39-497e-b3a8-2edb8b0b53e9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Copper Queen Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/484401dc-c1cd-4d26-9e99-5c49739bf05b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University Medical Center of El Paso",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/487b1ee3-44e2-439f-85f0-68e5e235e27a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Children's Hospital Los Angeles",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/489410a1-a689-4dec-abc8-32f802091140/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Garland ISD Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/48aa961c-db21-4ffc-8eb3-e4c75d7c7c56/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kern County Hospital Authority",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/48b0ed26-b687-4cf9-9aa1-7924cd98c950/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Mountain Nephrology, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/490f08f3-38d3-444b-88f1-9798dea724e4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Asim Chohan, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4974de56-3f16-48b8-8593-c9b5a146fe18/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Infectious Diseases Associates, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/49ec4064-7609-4f62-b5e6-20a05e00549b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kansas Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4D1ac_Ty5h2vV--oigqxzpJxwsTeHb_k/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Surgical Arts",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4Nv9eay1aGUcDHoNoFvAiD-lWQW2B96h/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Clem Kirkland MD Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4WhyRArSk37mMNgPi8abRFnIJRbnJPpW/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Excela Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4a05505e-47a0-4af0-ad3e-f068134bca65/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southeast Missouri Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4a0f2b1c-3433-4080-963d-5ef416dec69b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Memorial Hospital at Gulfport",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4a2476ac-8e51-4591-af31-2fc7fcc3fc0d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Concierge Medical of Naples, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4aa55378-e9dd-4080-8ff1-d4ff4a0842d3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Holy Family Memorial Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4b35bf5d-11a6-4809-9839-1b7cf06b2f4c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Facv Consultants PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4b3fb786-b574-41dd-9f14-c2679485ee61/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Winfield OB-GYN",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4b5a41d6-4f6b-4c64-a2f5-0ec9374f0afa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ralph Zagha MD PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4c236d22-a5ee-4e8f-ba94-5b9c7200c22a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Ellbogen, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4dcb773c-b035-4184-96ff-d8e4a6592906/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Azhar Khan MD PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4e25fccd-d74e-480d-8ad9-77a7a01a54de/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4e999ac6-c999-420e-9519-39e393fb5133/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fernando L Martinez-Catinchi MD PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4e9afe93-70c0-4e43-adb4-49ec1d261955/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Hypertension Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4ea8f953-b718-4128-8919-0106a77acc02/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Broward Hospital District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4ec99ef7-2f74-4efb-9ab9-a702c7c570f4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Indiana University Health, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4ek42qnrCibOKYPH3Swwzqc3pT1bonJw/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rostana Said, D.P.M.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4f354041-938e-4d10-ad51-d4d0faeb8f7d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Huntington Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4f35ff00-14bf-43a5-ae42-4f4f2c554bc0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ochsner LSU Health System of North Louisiana",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4f368659-4db2-486e-913c-e2c2f5852845/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ascension Seton",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4ff3b259-e48d-4066-8b35-a6a051f2802a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University of New Mexico Health Sciences Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4nwOwRkG2bMG2PY-W1zZZrlh0VQphgtr/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Iowa Foot Care Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4pSnl_JZLf4SWeoz2R9X-DNm9Ix_iwaz/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "PNC Financial Services Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/50cd0cd2-ca52-4b72-b171-92a8aa1b1cda/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "TPMD, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/512dcccf-0a75-4766-98d4-6cd215ee010d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Richard M. Sooy, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/51439fee-4f26-4c5b-b9eb-6e943125896d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "California Kidney Specialists",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5192cc27-2764-47df-a8de-8ad1cf29ade6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Michael F. Esber, DPM PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/51f96a70-43c0-40c0-931a-19c1f8bc3766/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mecklenburg Health Department",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5213ec22-3df5-4b49-ab92-487589c502a5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Mariela Urbina, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5235b747-55be-4dca-a84a-6c74c3aea914/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The National Diabetes & Obesity Research Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5253c5ce-87ba-4ca8-80b4-c943a8098fc6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Emma Goldman Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/52689f1e-9825-4b5d-8853-96de57ae62a9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Weaver, Kenneth R., MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5285d7cf-1d9d-45e6-b50a-a38a52ab319a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pomona Valley Hospital Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/52bd19c6-70df-487b-85b8-29be7abf17a1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Renal Medical Associations, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/53393c7a-0b87-4dcb-bbca-68e82f45f8dc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kaweah Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/53c0399e-61c8-4d87-b605-11883089184d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "NICKLAUS CHILDREN'S PEDIATRIC SPECIALISITS",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/53e6a1e6-ae3a-42a1-b1de-6de5bdf38a06/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Nelson Vega",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/547e0be6-20fb-42dc-9ff2-a10bcd0f2637/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "West Broadway Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/54bd9abd-9cf5-47af-bd4c-c4fcdbd30c2f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cozen O'Connor",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/552e9adf-a09e-43a0-9754-a0505c4f865e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Belladonna Medical, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5551d496-d540-4465-98ab-26d3cd0731b3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Alan L. Kalischer, M.D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/559fe11a-8e88-4e27-80a3-8c19d661fd5c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Emory Clinic at Coke",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/55a5c77f-3c48-4025-a938-86c4c8770d6f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Franklin Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/562bb897-15aa-4c27-8c59-a5185eb0d309/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Senta Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5632fbae-577c-4a2c-bb09-322e166c2db1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Allina Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/571892a5-3ae5-45ee-800d-36f0ad04078d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Premier Health Care Group, PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/57555142-fd4d-44f9-b414-6223f59f4079/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Margaret Zakanycz, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/57Qg7kR2kdfct_V85kTstH_EBqhrbO84/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Victor Valley Global Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/58256f15-b7fb-43f8-b588-0447aedf7ad2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "FastTrack Immediate Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/58454b2e-331d-455c-9a19-f10338217401/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rocky Mountain Infectious Disease, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/58a432b4-e1e9-4961-babc-ff3b87eb8606/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Novato Advanced Foot & Ankle",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/58af3cfb-25bc-40a1-b39f-a39b55dc2d85/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Riverside Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/58e257bc-e191-4a35-bf38-51c1ed2d9839/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tyler Holmes Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/597f09fe-69bc-4621-95bd-45f5516bc666/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kahuku Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/59b2bfcf-adfa-48b5-8352-526929b8ba96/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "SpiriTrust Lutheran LIFE",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5Gnoym9jLjd2Os4NZp-YnJHFwjsCsY-K/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cardiovascular Hospitals of America, International",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5QMHXtuuhmfMbm6YvBGNx6XMTSKhG4po/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Carondelet Health Network",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5Rx5ezruUpSXrd5Aut0-NzcXZSNNi8DC/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Barclay Internist",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5a379cca-ccf1-43ac-a865-97b631da6504/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Trinity Health Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5ac0007d-0893-4627-b11f-857c06d27ab1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Medical Associates Clinic, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5ad9a857-21fb-4664-ba2a-5c537d9921b6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Complete Cardiology, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5ae19d71-7c48-44aa-b10b-af198fa0cb1a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Philip Siebert, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5b1ccb05-83b0-455f-a36d-ab0c7e695794/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Roper St. Francis Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5b3de6b7-e81f-4297-bc82-78ac9e1083cc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dermatology Associates of Northwest",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5baf204a-7e7e-47b6-b4db-d848c55eb2f5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Coquille Valley Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5c5c3b5c-6128-40bc-b71b-102ccb82d7e7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Christiana Care Health Services, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5c7467fb-60f9-4172-add4-57667a5dfcfa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Health Quest",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5ce1dfad-1169-4dc3-a793-3ed399b70e67/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Community HealthCare System Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5d5c0d2d-0eb7-48af-8536-161bb1a08f58/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nutley Pediatric Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5d90a573-5ab0-4dea-9f2d-25a564909394/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Animas Surgical Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5e345d7e-ad6a-4acc-afd2-8a8d30a43ef2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Munising Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5f5b322c-2217-4325-ad8e-025b10008aca/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Akron Ambulatory Foot Surgeons",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/60151f1c-ed83-486a-b2ca-e2046f99f575/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Stanley S. Shama, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/60738f4a-38f3-44cc-a527-32ebee139f3f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cullman Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/60763645-ac00-4eaa-9f95-71337d5e80c1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Julie Lorber, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/60edb781-d390-460f-addf-01761109a186/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Positive Impact Health Centers",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6123adb2-d0d2-485a-9dcf-5fba87efb2ef/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Renaissance Medical Foundation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/615a8998-a903-4555-ae9a-819c3a1a157c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Brandon Holloway",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6215f07a-9916-4137-9055-84bc5a503a57/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Family Healthcare of Smyrna, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/623b1fd6-a78d-4d9b-8087-fcf4e551f4dc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Stony Brook Business Ventures, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/624a554a-fb79-4703-86d3-5d635620055e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Luke's Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6250bb55-ad93-47a0-aec6-517b10254738/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "McLaren Health Care Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/627b435a-9f3b-46fa-98a6-9a699e37eec6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pandi Capital, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/62f77950-855b-4619-afdc-c0f78ebee30a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Uniontown Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6321ff6a-a314-4d0e-a6e5-3ccc184ce01b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Winchester Foot and Ankle Associates, PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/635f51c4-b647-4331-af69-de60fc5578b8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Davis County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/639e10d5-cd9b-4520-ac16-cab58cec3fc7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Martin Luther King, Jr. Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/63bb0c78-dbbf-4de7-9bf4-daff7df1cfd4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fairfield Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/64706c27-8401-4242-8ca4-f0b7c493efc2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Baptist Health System Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/648185ca-41c0-4f17-94a2-541d6b66987c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lakewood Foot and Ankle Specialists LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/64878668-706f-45bc-9263-a39f3c254f68/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "VHS Physicians of Michigan",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/65462acd-8903-4686-b436-2e6d88ad8c3c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mercy Medical Center-New Hampton",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/657e1fae-2721-4373-98ee-a5ae763a6e77/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jay Jazayeri, MD., Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/659004c0-9168-411b-8f01-5cd89f032f16/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Basel Refai MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/65979035-1557-4261-8de9-caa332ef8187/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bermuda HealthCare Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/65d70687-657f-46dd-a08d-5ecc4ca15ca5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Yukon-Kuskokwim Health Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/663c4c6d-1396-44a4-b589-c11a968d4876/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Penn State Health Care Partners",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/66620725-6ef3-4a7f-a15f-88b48c4af7dd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Family Footcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/669434cc-a457-4ea9-9824-8a9fc6bc2975/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Virginia Mason Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/66ad9a50-d7f7-4c21-b933-2ba90047388e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Allen County Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6724d0cd-db84-40bf-a313-88dc7a6cd497/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Empower Psychiatry and Sleep LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/67e5ec72-de88-4fc7-ba34-a88699b7a637/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Marshfield Clinic Health System, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/67ff075a-8289-4f2d-a8eb-5dc1f0d954ab/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Joaquin Gomez",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6859fc00-fade-4513-94e1-93ef2b0f345b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Yeaman Signature Health Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/68902e51-a40f-4bd3-a87c-4a2e859e7200/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Oxford Hills Foot & Ankle Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6978cc8c-2f09-418c-808e-8cf4513d296c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southeast Georgia Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6996dfed-5d48-4d59-8b7b-8bd86c9887c0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "IFAS Management, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6a316867-5684-4988-b95c-94ce28d46d1f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ultimate Access Primary Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6a4397dc-1436-41a9-b8c9-171f0d1bd37f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Navicent Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6aa95184-89e0-4f55-9015-d41b71e7debc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pickens County Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6ad4f704-f405-4202-8945-20913573c2bf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "West Alabama Internal Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6ae415b4-ecb2-449e-8c4e-c5f9a5303c05/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Thayer County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6aeeb1a0-1a0d-40b6-a477-0bb70c9416f3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Greenville Surgical Clinic, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6af660a6-1deb-4c41-a9ac-8c8750f37b1d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mitchell County Hospital Health Systems",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6c22a45f-4292-4a09-83f4-40d88482c128/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kamran Khan SC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6cca5710-6b31-4150-9a3a-a57cd751124f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UHS_Ambulatory_East",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6d80f5c7-212b-4be1-9709-7bad9391b694/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tift Regional Health System, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6e2dde13-d4ea-4659-900f-6a252ed00859/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "David C Morley Jr, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6ee7bac8-8522-4f04-83ae-d5a91089775d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mobile Doctors",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6efe5d3f-6bb6-43d8-8f5f-20475bdac09b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Joseph's Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6f2341d3-c614-4a71-9cef-bdca1a222d48/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "The Rutland Hospital, Inc. d/b/a Rutland Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6f43d0e7-6ff2-489b-abdc-44e8a5e0ca0a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tri-City Primary Care Medical Group, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6f6fa04d-6294-46cb-a755-92fcf4395ad8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Palomar Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6f73eb02-7a46-4cae-8907-0208d6de890c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kiowa County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6f9e2eb1-49bb-4863-9a96-e4549126af91/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Renal Associates of LaGrange",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6fa252c3-32fe-4cd1-9a6f-9884e79f34f6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mary Free Bed Rehabilitation Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7006fdc7-df54-41b9-a969-0708fc6f2031/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Clara Barton Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/70091b8b-c363-42f8-b4d5-3b99f0fb60f1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Alabama Foot Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/703ad69f-3b2b-4332-b74a-2a8a2b8cfcf4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Mary's Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/704af85e-ff7f-4141-a47d-5f79ab640202/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University of Tennessee Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/70957d54-2475-4916-a6e9-8796f340a1a0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cypress Pointe Family Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/70a7ba3e-322e-467d-9b30-758e8960bb08/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sarah Bush Lincoln Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/70a80a72-e84a-495e-83fd-937e0d2effcd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Kumar",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/70d6fbd2-5812-4281-8f18-df88161f8bc5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Lucia Zamorano",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/711b57d3-78b2-41c6-971b-59cee3e8c70b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lake Havasu Unified School District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/712e1ffa-9f67-48bf-9982-5320fbfe6aed/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Care New England Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/713ac9f5-15a6-4520-831d-8a5ba81c49d0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University Hospitals Samaritan Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/728ef80e-de1b-4c4d-b27c-2c7ac1cd8b9f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northern Light Mayo Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7327d6db-1ee3-44fd-8eae-02972f435e62/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Meridian Medical Group, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/73bc01f5-9bdd-4e4b-ba52-efb00b8cec28/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Richard S. Warner, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/740aa98a-caaf-451b-aae6-eb82372d1859/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Automation Direct",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/744c96da-65d7-4e37-a00c-996f4b604c11/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Children's Hospital of Orange County (CHOC)",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7477d6d6-6e4b-48c8-a228-9a3bdab172a0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rehab JV, LLC d/b/a Sheltering Arms Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/74ae929c-3b50-4f7a-9a1c-18042b69a652/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Baptist Health South Florida",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7517efed-1048-4d65-8b97-98e147342cf5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Kenneth Treadwell",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/757da266-83a7-4662-92da-34d0fca08f54/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Maury Regional Healthcare System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/763a86fd-c545-483a-9179-bb60864b329a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Glacier Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/766713c8-6704-4cf2-bcff-6dfc96f148b0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sumner Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7727cc5d-24db-49d2-897b-a2a11f267be7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Affiliated Podiatrists of South Jersey",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7753d029-0f68-4c26-8081-55eb23bb5866/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Perry County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/775a5afe-736f-4ab9-8474-145e99d69207/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pagosa Springs Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7771e67c-eed3-4c07-8b39-4ee1de7dfb76/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Adventist Health Delano",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/77b46b85-adb4-49fe-86ec-bf3171ce92c8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Unified Government of Wyandotte County",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/77cef438-d9a8-4c2b-a90a-6d877ebd2afb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Trinity Health Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/781d290a-0fb7-4574-b825-dd38fe495caa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Asquam Community Health Collaborative, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/792eb4ff-2422-4781-8cdc-7969fda08ada/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "J. Fernandez & R. Molina",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/799e5f79-6e8d-46e4-994e-0573f8c38149/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ascension Via Christi",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/79a09fdd-d4ce-4b27-b1e2-f7fe68705a34/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Texas Gastroenterology Associates PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7CLnKVgLsZxSnfsPqWs4-5n14oIQd_lY/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Drumright Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7MMBL3BwmimcCY3EJOOPMfwuAMJQI7-q/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Laurel OB/GYN",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7a0e2187-5703-429e-8775-3b6e1de88486/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bright Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7a28cae9-484a-40f3-b791-f158ba3cb413/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Indiana Spine Group, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7a3454c5-556e-484a-9fb6-35b5426763b2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Simi Obstetrics and Gynecology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7acc477c-8372-44ca-ae6e-bcc04c61490f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Black River Memorial Hospital Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7b17929a-d976-4002-b080-2a37b05f2444/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Castro County Hospital District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7bceb249-cbfe-4868-961e-9518d1afdb86/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Anne-Marie Gracia",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7bgA5p-Jyk4Mxwneej09P02G7MB2Ivog/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Coulter Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7c8c7300-43e9-473e-badd-c134996bff81/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Sonny Park",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7d7f9694-46c9-4670-abeb-9400514e3b75/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southwest General Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7e89f9ba-2516-4eb3-98da-9f8cb196a8d0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Healthe Employer Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7e8a1d3b-132c-4f07-97be-f81fc4642359/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Inspira Health Network, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7f0d0b79-8c30-43ae-a149-9e0c2340daac/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Refugio County Memorial Hospital District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7f96711f-afb0-4764-969a-c5d57fe30c59/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gwynedd Mercy College",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7f97a135-de8b-4d0d-8cae-944f42aa5be1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Donald M. Birch, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7fIEmT-aoS0xFmowQrxBz0hBdpd93tVq/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "ABC Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8004d35e-3cbe-40a8-8f64-f3def78d8499/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "BRMC Medical Specialists",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/802a71be-a559-4f91-97b8-8d4875271bca/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "M. Munir Zaitoon, M.D",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/803d7d4c-e9ff-4575-b218-a37e8af02d5f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nephrology Associates, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/80a80d81-3c72-4157-aef6-3c0ada81718a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Missouri Delta Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/80babf0e-2f7d-4b87-9cc1-ea74c9b22a40/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Texas Tech Health Sciences Center - Permian Basin",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/811b53d6-0f4b-471a-8da0-071261666340/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lata Mundkur, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/812e0a2c-a2ee-43b3-baef-01bf949ae18f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "MCHCP Missouri Consolidated Health Care Plan",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/81eb3df5-7690-4c07-9f5d-6ffda1c2ed5c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Associated Podiatrists, LLP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/81ed713e-778e-4b5c-9b69-03c747a235d6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Emory Healthcare Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/82392e44-ab37-416a-9704-84edeee58386/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Madison County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/823d67d6-97c5-40a2-b084-56d06cb82099/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Peter Barrett, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8261cbcc-fb41-4727-8758-abc015287dfe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Billings Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/82a4f2ea-0df0-4313-99db-50ed1f3e0c13/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Coastal Pulmonary",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/82b0ad09-dd0a-4a8a-9439-0c935213f8f1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Prisma Health-Midlands",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/82b5c78e-3511-4091-8bf4-9b7dbe078f0c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dubuque Orthopaedic Surgeons, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/82ffc56e-a8c8-428a-a28b-8c9d0bafcb76/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AU Medical Center, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/83090b64-9cdb-4df9-93d3-bb2473dfa7f3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "ENT Associates of Metairie",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8348592b-95fc-4d23-9be6-0b25765fe907/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sheridan Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/84290569-a747-4440-964c-bf6fb9f7826f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kossuth Regional Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8461b39c-bf4d-446e-92d9-25827935f03f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Atlanta Infectious Disease Specialists",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/846d4f57-4fd5-404c-9981-9b5cd4ada783/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Baxter Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/84d755f8-a304-4a2c-b470-52d3a7d1b018/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Podiatry Associates of Lake County",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/857e4dce-dbf8-4809-829e-aec4eb97c695/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Bob Health Centre",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/85966690-f0af-4f43-9fef-36dfaadaf204/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Surgical Multispecialties Medical Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/85e438cb-0cb2-4c78-a169-d659fe5b2dde/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "PAMI",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/85fee1ae-75cd-4cf6-8306-8335ac01dc49/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Padma Gupta, MD, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/86251441-7ffd-4c0e-91b6-1c16f5c92270/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "LCMC Health Holdings, Inc., d/b/a East Jefferson General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/86c11601-5c46-46d5-a746-706bd2e9f00b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Viasat, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/86fe2a9d-7304-48e6-91d1-0feeb3fee8ac/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UHS_Ambulatory_Central",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/870ba945-f258-4fb9-a3f5-2c79586392b9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Medicine Lodge Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8772d9b7-4fc0-47d2-b0dc-6592e9edd5a0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nisha Varghese, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8778d8f2-34ff-41a0-84f8-16d4375c53fe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Steward Health Care System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8854b3cd-c586-4c9c-8a36-36c9261a59cf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Whitehall Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/88Br3I-ehV_mZejJLzCjr37wE_2hm9s-/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cathy Berens, NP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/88e82c33-1d49-4d68-b406-6fe26c643c6f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Phillips County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/88f6f0ad-680b-460f-ba7c-9dd496dece04/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Carroll County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/89am5gSIswYvqOJuGoJ38cMjxUeNFOma/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mammoth Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/89b7757a-432f-4f56-8638-86920235f2d0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southern Iowa Orthopedics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/89ded511-67c4-400b-8714-ed51dd046b01/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Podiatry Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/89eb3e3a-72ad-4166-b9d4-91005de7fa29/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Juan B. Martinez Jr, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/89ef8fdf-150d-47da-bc0d-912cd1a74b4c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Western Oh Podiatric Medical Ctr",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/89qRxg50XNEvJ1rMzQ6E1GUFVYLjKcWl/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fort HealthCare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8F7ruIta-JA7ecm4ommy-Q50dF1FkFe4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hollister Incorporated",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8a1730d0-bc79-40c2-8aef-2fa30e00e904/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "One Oak Medical Group, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8a279096-6ad2-4c68-ac31-bf88e291604e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Metro Obstetrics and Gynecology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8ae7fa71-909e-4322-ac88-fac3d825c75a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Complete Care Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8aea60f2-7e84-4f0f-9c4a-ad23740ef3c8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Astria Sunnyside Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8af40abf-26a7-44e3-a87a-572c3d78131b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lane County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8b00a59f-c52d-4a54-aef2-92355b29c54b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Richard Price MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8b00b995-da1d-4629-ae3d-d15b056f592a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Glen E. Hurst",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8b21b716-2aba-46ab-a59f-946c67cb0eb9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Richard M. Adams, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8b5675f4-fabf-49b9-90d5-2630480a3d7a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Union General Hospital Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8bbd570d-db8f-4e0a-abe5-48b447c735fb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "General Surgical Associates, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8ce5d363-ea3e-4f6f-a99f-e6d83ae8306f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "County of Ventura",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8cf1bb66-7b18-4eaa-b641-538f19feb923/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "USA Health University Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8d555f5f-2441-4690-bfdd-d2697379c3d6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cook County Health & Hospitals System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8d8e2b72-238a-4f00-88a3-8ba1a0a2d561/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Americo Services Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8dc8f3b9-781b-44a1-8832-9b919d42e2ad/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Abigail Family Medicine L.L.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8e2e78e9-d967-4216-a71d-852255f558ed/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Albany Surgical, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8e2ece22-3efe-4cb1-860b-5b67b6cf3ea9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bellevue Heart Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8e5952e2-57ae-4f09-837e-37dc76b6aa95/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Comprehensive Counseling Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8e77b480-944d-4d4a-a93e-e5a9fd83d5c6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nemaha Valley Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8e95a1ff-1887-4987-a791-2170776e0067/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hawaii Foot & Ankle Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8f6ecc28-1041-4fcd-81c1-b28615978693/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ector County Hospital District/Medical Center Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8f9a7649-0fa8-479b-a649-15bf2ad877a3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Allentown Family Foot Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8jbgxuNWdtuelGLFHIXdkqcQh-JLjFrK/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Long Island Surgery, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8u8tjEclnkYFNZ5jrEAJ1UOfzxVcOv0c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Raymond D. Hansen, MD, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/90c1c564-ec35-4c40-b3c5-6cbeb6d0ad79/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. James Russell MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/90e0c07c-ef75-44b1-9b9f-f5e17886a9ca/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Regional West Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/91542431-e1b2-4164-9745-f5cf28cc4ca5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Manila Zaman, MD Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/91c4c3f3-36f9-4b17-8704-234555a2c4c6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lavaca Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/91d3bb95-7713-4c15-beda-b8a73ec1b5e6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Huron Valley Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9294b782-b770-4d24-ab39-7040e4ec8d6a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Stony Brook University Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/929sni9vNtBT8k3NbtgAnVZlZv_TYNXC/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northeastern Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/932b43fb-c766-413c-a343-640549d20cb3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Healthcare Exclusively for Women",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/933edef4-eba4-44c0-a5ce-a34dcfcf6c06/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Otakar Hubschmann, MD, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/93462298-4bdc-4b5e-ab96-39df8bb9a9b2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Internal Medicine and Pediatrics of Cullman, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/93522848-eb1f-4ed3-b857-907cddfe003b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "ASCHINBERG PEDIATRICS",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9376d5c9-afda-4b32-a319-0c1c159dffd7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Richards Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/940a6958-277a-4baa-b4ad-64568a7458eb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Primary Care Physicians",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/948ddc3f-5cc9-41d2-8d7f-5b15b32755b8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southern Orthopaedics & Sports Med. Asso",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/94907365-1bae-4b91-8efe-455bfcdb37f6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lewis County Hospital District No. 1",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/94967595-d5d8-4052-92a3-32cb047ee8dd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sharpe Medical Consulting",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/94cbcd71-bcb5-444e-b8e3-2b9b0923b3a1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Montgomery Pulmonary Cons.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/94cd7aa5-f2cb-40d7-948e-fda3af64de2b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "LifePoint Corporate Services General Partnership",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/94fb32bd-11fc-46c8-aef4-90035a0718bb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mobridge Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/95143858-4077-4cf1-b5d2-c2a999f62bb3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Philip Gachassin MD APMC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9529c62f-bc91-44f2-abdb-c398d2e65a54/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ozlem Goker-Alpan MD LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/95bfb368-cccf-467f-b483-6c8f83ef71d6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Louis Kansas City Carpenters Regional Council",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/96697297-dedb-4b9a-a814-def7ebf7578f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "New Birth Company: Kansas City",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9680e723-25c7-4fd0-85d5-1a4b8d8c4e0b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Variety Children’s Hospital d/b/a Nicklaus Children’s Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/96fd612b-7f6c-4509-9e0b-25e1bdc16363/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Francis Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9708be61-c717-4b6d-90d3-c1efafc5bba6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kaleida Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/977e949f-0f0b-4a36-bf59-4f0819b90ab8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Carroll County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9785b033-fa30-4746-84ca-c07c9380c88e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "O&O Alpan LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9786e81f-9564-4e31-8df6-fde152b07608/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Delta Medical Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/98457c6b-63ef-4752-8922-1770c81bf95b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Uwharrie Podiatry LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/98617d0b-48d0-431b-8ad4-46d64800d954/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Carolina Neurology and Sleep Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9866d918-4ba0-4040-b294-ab19b8bedf0b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Free State Dermatology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/987b7d37-b031-4fc2-a4e7-a26373f40c27/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "H. Lee Moffitt Cancer Center & Research Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/993df7f9-6163-4b2c-9388-9d472c4ef3f9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lubbock Heart and Surgical Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/998628fb-23ae-4895-80fe-41f7930e56a2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Olathe Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9997a5fc-aad4-42a6-b005-45276937bbd0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Harrison County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/99ffa44e-e4f1-4a92-b7bf-d707fe48f277/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jackson Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9NRYwNOTpYhpe-Vh6-aSWRYPlx02SAgP/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University Medicine and Cardiology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9V4jT5mKo7NZgJpxVx0fBwOkw7fWIJBf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Osmond General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9a33b0f6-bb54-4b97-805f-5e0a81abf079/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Family Podiatry",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9a5aef48-14ba-4f58-b31d-60b57310cb21/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Abbeville General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9abe5281-fb44-4a76-833b-172cdda3a495/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kuakini Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9b1379b7-10bf-4227-b712-fc713ef35c39/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Springfield Pediatrics - NJ",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9b1dd89d-f09d-45d9-ac67-d4ba4699db91/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Timothy J. Killeen, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9b2bceea-9933-492a-a11c-72e48b2960e6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ottawa County Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9bff9324-b2ff-4506-8825-324d6cd35169/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Perry Mansfield MD Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9c14889b-5c15-4fbc-9176-47ac68d769a1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Urology Associates of the Central Coast",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9c3d5f6c-4d59-4a7f-9170-c96c3d9e561c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Central Jersey Sports Medicine and Orthopaedic Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9c59f03b-784a-48b1-8226-af2410d7e79f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "McDonough District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9c9d3cdf-0f7f-4b63-979a-f711747b3e95/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Miami Associates in Pediatric Surgery, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9d02172d-d861-4f2f-87b5-3b1c5ad61f32/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lakeside Pain Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9d6b5484-5a6e-4277-a298-c488b306f27b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lincoln Community Hospital and Nursing Home",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9d77d985-edbe-4a35-adeb-c90c1d0fe7de/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southwest Regional Rehabilitation Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9d82610e-4f6f-4003-91b8-cb7b25e81276/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UofL Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9d8de80b-ba56-4cc1-9cf8-cb9f0520d151/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Covenant Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9d9ce2ac-65e8-4488-a0f0-ba102e060a58/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Robert H. Flannery, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9ebecf01-3d92-4d80-8298-e431bde0bd5e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Alan Yager, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9f256476-d263-4340-85b9-e872137a0274/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Alfieri Cardiology PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9f2b41af-66c5-4f3f-b955-096365a05e2c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "United Hospitalist Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9fc30ecc-7a77-4f7f-b2de-a7bf4f53247e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Jeffrey J. Betman, Podiatric Physician and Surgeon, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9fd8edc6-b948-4724-a29c-1558edd5eb23/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Monroe Foot Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9feb53c1-4d54-4b5c-a925-41e507b3918a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Vincent's Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/A8JBVvRX_lChZDLoNxFeQ8N_64m_7so-/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Robert Sussman, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/APNTfmJzokp1NjKs1VyzBk1ajdBrJYMF/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Everett J. Mason, III, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/AcoGxeqgq_UrHoDpyzXXx7HW8reQGSlo/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Trinity Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/AdmVvrbHriE7AWDLGoyfeuamNXOy9O_a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Methodist Le Bonheur Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/AhjJMjQtLMWypw5HhAKlG2VQs9XvM676/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "MacArthur Primary Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/B5Y5ZienVxjgCQmW_iKfuE1CW27UK8yA/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ohio Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/B6zQPDzaWeVOqzBJ0Sh1xK0jNxcImGGn/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Insight Hospital & Medical Center Chicago",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/BImYYihq-pkQ_BjNU9dZcYYz6hkmX_7A/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lawrence Cheung, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/BY9je2QQBegY9p6M_ESNA4Q4nh7IiN-r/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Suburban Foot Physicians",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/BguK45g6jzlyWbV8aA_pUBqa6WtQIC87/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Einstein Healthcare Network",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/CZXZx6LxE-L3UYv_vYuZuKXOvALyMhgz/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "West Jefferson Holdings, LLC d/b/a West Jefferson Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Cdexwx1cxINR0Iguyu5-xIb5GOBkUQFE/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Caneva Foot & Ankle Clinic, LTD.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Cjes5HkVls0-AOSEdGoBEur2OUfYZvUw/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Munif Salek",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/CnXmEagKas-yXlBLaNNR0bxofL-jnEs3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Jose Pena MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/DM0AwKVZp31J_av2gClWDZB8oYdLOUJ3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Torrance Memorial Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Dbsl25a-uo0gf9Q0PnfwA_QlUbZ5qTHL/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Baxter Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/E7o20T_kvrkmWyJzCB8osorjliMeLXLl/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Health Partners Management Group Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/EB87749h5gFXR747moCjBvZnLkChVxMK/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Edward Yavitz, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/EZGME5eaCSDAVOXwAl-ayebjMHV3ysNU/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Solano Kidney Care, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ErJOAfNQnxUFOkKvroFspS3XwC0I_BKr/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "CGH Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Es63ilPkkETpas1hoRy0bFNgpWFGLAl3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Beacon Medical Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/FXKD-Xb5DUX7GYMomaomI02W6AvYyCGp/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neurological Surgery Associates, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/FbEd2u1hjjAzrJT3wpsP33KAKZk6Vh2g/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lakeland Regional Health Systems, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Frl5JaixaVfSFyjwSToZ4YMYtvsBctDq/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AdventHealth",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/FvWTgpuArzkbnSoZ4uBB0nfVO05IjePF/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sicher Foot Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/G__Wo5W0WCpQT7T6QvV3hXEro56vpA07/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Singh Surgical Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/HHnW3DiyRSQ3xCoCWdDAngjb0weHlq9K/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ridge Family Practice",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/HYem62jAGgg_5fV9EEjMvZqF_I7hxCPq/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Advocate Aurora Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Hhyp0HLTvlWluJy7STHeGfBt6VssX-DH/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cartersville Ob/Gyn Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Hn5sEtQzojwI35Jt9y2Zkrc_h-YSYc1T/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Genesis Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Hq9lMFKIau9MlCiBN698ZPzTKNvsMrCb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Oklahoma Heart Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/I-7_h5bO8aC4DcrZl24eCXsg8gA1KGV3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Steven DelMaestro, M.D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/IO_kO4Kkq0aG92emh0jZF2-SsK4nWzI-/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Glens Falls Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/J3Pj9g-143lbW_EOI9Oq1DsbsQDB7jLs/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University Dermatology and Vein Clinic, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/J3trBeALwJU1F3hepm2v21jJ96hxu50P/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kennrick J. Dennis, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Jq1h-Z1Yyu4OyupN7ciHN171trNUbJQP/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Children's Mercy Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Jst2t4B3tQ_LvMKd5zgnH8scFXxFjMAP/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Montgomery Rheumatology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Ju4SLrJ8HE83ty66H2bgjEBnrvB-FIla/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "West Central Ohio Podiatry Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/K-cN4tVgW_1xlTS_2tRMxdUMCQhBSDfG/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Michael F. Lett",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/K50zk9n5d0FtfHiP6kL9kMMGuWk1O10F/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rockland Thoracic Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/K7r0JqNzwCCreORLHDZNhTb7SEfo_ZjL/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UHS of Delaware, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/KOZ64ZU-fJam5DNQB3C21wHed7uKMN5J/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Onslow Medical Specialties Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Kh3I89FnZzehL9RP43jjzXcrZ9CMElX0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Beach Cities Dermatology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/M1jf01xe1APukiXfw25S4b_jE1CIaZBQ/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mohammad Ismail, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/M2R0_m2IUHctNyO_gPCACDfAwqslpW-C/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "James M. Hurst, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/MRCAWChGRfj5b1ODnhqVgy_ttSr3D2p4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Memorial Hermann Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/MgfJfJ70Dbsm4ZMgvz93Y8Q5rmD9yGq5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tucson Physician Group Holdings LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/MmWbh382tKlbvAIA1_DeLlIjYVSwroch/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Richard Burkey, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/MqJcwMg9cqSqwyzaFu8TFRHJQ9biDbIM/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Kansas City Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/MtxVU3dbzZwHcvfCb2vTAE2_Nwhai9Oq/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Texas Children's Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/MxK8wHcGbqmwQq7QQjRRi4fnIgSY1-t4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "MidAtlantic Eye Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/N6G4uZFC_0VHckv5d67VADXkySFwDJK1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Penn Highlands - Dubois",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/N7LD0qx6O97vWG2K68nV0s0G4Xzq2rtM/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ballard Family Medical",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/NIiS30uhuk8X8j0rh7g_x24gSD2gAgj9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Valley's Kids and Teens Clinic PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/NJKfTJEh1zcbACZlgIDQXFg1pMIt6s2k/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Syringa Hospital and Clinics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/NPuuJBwmCt5825nd4RiHb2IYqE3xpZAv/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Florida Neurology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/OOz5hkiC68x4B2tV8TWG2SVCrgoGQtPF/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Oaklawn Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/OSDxeVkxstnXkDtx-wIZj-GXD6nmeJaU/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dermatology Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/OUq4sfoCPKtQL-ACHoGyRXMXcfN_WjFC/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AdventHealth",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/OgZyfqFCSddL-itIAURNqB8312aD4fxe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "East Bank Gastroenterology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Oy9v_722D9bcevVKOcXOLbc6xptKxGMe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Scott & Nathan Rickoff, DPMs",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/P3K5yw8GMf20why_cGnqwmhZY7-3ViDb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sage Plastic Surgery",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/PBxXyBpjIJSsFZVJZMPquS1RJJ3_fyh3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "S.P. Associates D.O., P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/PYvsXOYiL9Kg269uLlyr8nOudyrp1k0M/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "First Coast Surgical Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/PlW-EjC8LXq2pLtfi8pP4Fb9PQcNWAMu/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cayman Islands Health Services Authority",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/QGFlV8qKdgYu-vPpMAoQW5U4Jb7riiI2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Children's National Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/QvKCOrGcsj2hJ6sASbt18oYJYaBlOEXZ/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Billings Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/R0BnjtS1Cg4P990d7iegvoMVqlnOQ9OI/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Adult Internal Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/R7Xi5VKCF7I0nz39ERM0XL_mBu0AaiHV/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Vatsal H. Mody, M.D",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/RNC0mGAiXtkLtK00WOVGaq2OiSLKKj4V/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "MacArthur Primary Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/RSiVkOMaHv5sLlFx1B8RLDUMq_Pfsl_h/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pawnee County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/SjBKUOzn0fvamYJNg6kz0qALjGnkLLd4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Penn State Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/TGXOUQhhs7VZuyPcDzWX45Uza-YlRb29/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sunnyside Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/TGXWVOelATtk6ci_q_H9utj9QjU3VuOR/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jay G. Levine, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/TI7fF1-TbIN0NND9yAO9GkU8NUabQTWT/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Weslaco Medical Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/TsPhzaqUt_a0RHCDBKHbD1NfbKTYyx5W/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Riverside Medical Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/TtBa6m0CO2ykz03C9oGIAfs1lSi1ZBkp/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cerner Healthe Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/U23aYKs_PV7Hmhkg4hb3eaygsqW71fRD/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Montgomery Rheumatology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/UHCaxLDJ6puwMRdSj30hJ8Nw05sTySuR/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "NorthBay Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/UMZ-Uxn6V9x08sH5gCnG-5yPg9ZX7et6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Edward D. Hutson Jr, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/UmST5Nz0TFWN1WTGDQw7-TwaxvLREKn_/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Anniston Neurology & Headache",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/VFsZVt00usha-W5_7KX0hu6HzzIrMX3Q/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Patrick J. Clauss, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Vc_QWiREZa95EPT5Nx8RKuWcE-Mc1NaL/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Trinity Health Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/VkFM4mA0c1aMGN2-7G1Gfk8QPbj_neXe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University of Missouri Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Vo3nb7XNL_9G2kQXBPPW3-r0QcpkrCy7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dubuque Orthopaedic Surgeons, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/WFOlwheC6aKuCJYbPTtM9YxT0wMlV2rb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "San Antonio Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/WKlSSS89qvhKmD7tJUsOt0whh7EBmDD-/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kado Podiatry",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/WQkVjQa0YhqVbUBQhUWeiP3ltAmffqww/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Family Podiatry Group of Tampa, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/WpueQ59D-7qcu1Z24coDRM6Ii1_UOg9Y/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rochester Internists",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/WwToQxBJNcC5xuy44-6eC2mX1ULkeGiM/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. John Health System, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/X1J37H-QXH9V3MP4KYWMOTDwG4C2MnHw/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Baystate Health, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/XLdX047SCzOOTrtRZ4O8eaQwl3uRN9YN/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Shahla Medical Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Xn4xUXZWRzcyVaayUfDGK1rXLAig3w6X/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sharon Regional Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/XxCJ99kCIg2i3KfxlKhrZa_KjVzO5m_9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Banner Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Y62ncCuwN85GGa7s0iz44XRnQoc9qr60/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Family Foot & Ankle Clinic, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/YABuj1qyp0U_XWojJG2Hj5hEws9N2IN7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "S. F. Hartley, DPM, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Z-NGhaoKbaEuTYlFPEiqS3Vb3zxVYtv3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Albert Boyd, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/Z7xHii9RfplEhMFkoLTbtu4zeKZi3tFC/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "U of L Physicians",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ZDeZ2YCfDO83BznnU2d6jrTVmnIa197z/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bryan Neff, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ZKUyr6Kl3RZ_2jbMXb86LpQdf9wgFkxb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Floyd Healthcare Management",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ZfysrRkN6BMVsGu-olfQgalxgHmZoVii/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "HCA Florida Citrus Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/_Q_nrOmD9N2KAAS0PB_pqGQ9_bB3ecQc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "David H. Warner, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/_byMhQ2TvVtBFrxJSYiBZz55T5g1Rbw2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "BayCare Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a01cc5e9-1755-468c-b41c-495a18dec39f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Antelope Valley Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a09bca45-00ba-4256-923c-f4e9ac2f9535/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Barnegat Medical Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a0d69a10-dbbc-41b9-901f-3656554c58e0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "B.K. Gupta, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a0e6d050-95dc-4004-8859-fe5d0d9bed79/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Irwin Buchwald",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a1a7e971-49fe-4ce0-8575-d8dc8b864c18/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "CoxHealth",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a1b70c2c-780f-4d21-a690-3d71302d3d4f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rankin County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a1c02c8d-1bac-499e-a65c-6c958b95811a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UCI Medical Affiliates of South Carolina, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a1e03df3-d2c1-4196-a5dc-f9fb4460babe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Barker Sleep Medicine, PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a2046a67-5779-48ce-913d-700822c2360e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wichita County Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a23f1f77-4149-4903-a9ce-5c317ba44205/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northern Arizona Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a2460eef-8cb2-4549-ae05-e195b0a28c42/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pana Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a264d319-abe3-49cd-84c9-cb6403a03aa6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "PAMI",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a2TfVcNaJGlijn6zzBhUnZFJmQJWpoQ7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Clair Pulmonary & Critical Care PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a2aabeb9-840e-4290-b28b-f0bb3ed955f9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Leland T. Gilmore, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a2be18e0-7f28-4d4f-a48e-668c32f30fa0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Edgar Sandoval, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a30d0d06-099c-49a3-9d40-270ed7523c28/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UPMC Core Zone",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a33bb2f7-1f6a-4097-bd5f-175f3ee1706d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Adventist Health Tulare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a36dfa71-4dd3-4608-9cfb-c7a63ade5531/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lewis Hargett, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a3d3e55e-4682-4bdf-aa49-2213dcdd95d7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Casa Colina Hospital and Centers for Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a477462c-6289-4395-a870-ea27830a6de9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Memorial Community Health Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a4c7307b-5132-41db-ae59-8b3c5b480948/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southeast Georgia Gastroenterology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a5287c52-a68a-471c-ad99-6b7cc3d9fc8e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Goose Creek Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a59cbcd4-c01a-47b0-9162-736ddb19e2b1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Children's Mercy Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a5d42041-57d2-4517-b428-b2228e570f69/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Surgical Associates of Atlanta, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a74b5677-a506-4100-881e-d18e68399558/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Albuquerque Center for Rheumatology, P.C",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a7511550-a8b1-48d8-b97c-d2a4596e52d2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Orthopedic & Sports Medicine of Saint Joseph",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a75267f5-7095-45ca-bda5-935aade48fcf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North River Primary Care Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a7589f07-8bb4-4104-b753-dd6b92bda7bd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Escambia County Healthcare Authority",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a7b7f339-eea5-408f-8f14-ad4341b10c45/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Reeves Regional Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a7e8884c-0f8a-4040-a7e2-b8409572d6c9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Engineered Floors",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a81eaf84-1569-4eed-953e-1a3a88244dfa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Biltmore Family Medicine, PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a8569da8-2be1-4a1c-a10c-8effbdf16e4c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Shore Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a873c085-bb43-46f8-8d4e-db05392761e1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Miami Pulmonary Specialists",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a8e6f633-5cc5-4e18-8fe7-d085d8909630/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neosho Memorial Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a9daee2a-e42f-4702-9c42-486fbda403f6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tulane Doctors Connected Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/aE6oKaDmDLfrLKjprLJ-m3sxRFENsPKE/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ocean County Foot & Ankle Surgical Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/aa8f482a-8515-48ba-93c5-7ed1e81290f5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Awani Kumar, MD, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/aacbdb31-a2b4-4f14-9ce9-7a927513087d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Centra Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ab208292-75a1-4788-9fc7-1e9a40a7eee3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sweeny Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ab4ef341-80b4-40a7-999d-52b52314ec6e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Regional One Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ab796338-ac9c-40c5-863d-ce75caaa302c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Joliet Pediatrics and Family Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ab7c4f67-c555-4831-81ae-f83069aface0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Dominic-Jackson Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ab90de31-4edf-49e3-8ce7-d37b2fb89026/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Skyline Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ac6e817f-dc27-43e8-b886-6559f137e853/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Billie A. Bondar, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/acc087bc-aed4-43c6-bea6-f2d5e7395282/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Orthopedics Unlimited, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/acd48832-2c61-46af-89fc-a48e69546675/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Republic County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/acf4b954-5b17-47d8-9d5a-ae7d4cae4b35/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Adekunle Adeoti",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/acfb0414-085a-4a86-bff7-56c553089272/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Simpson General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ad408f3e-a4ef-4981-b9b9-d19f9315fe54/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hiren Patel, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ad85122c-2b5b-437a-b79b-6ab4b32cc134/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pacific Neurosurgery & Spine Medical Group, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ae3cc072-efac-4b88-a7b6-55306d11cb60/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "H. Charles-Harris, MD PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/aeb798ea-59c0-4b01-80ca-75ffd22a2d37/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Saco Bay Podiatry",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b18afddd-5a75-4a7c-bf4d-c04c2efb8f8b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Swisher Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b1ca1c78-3ab5-405e-b1b1-fc89e2712a56/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ventura Eye Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b210b38c-c8df-4e23-a364-b958c576d48b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kids and Teens Pediatrics of Dover, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b2acb63a-e605-4540-a24a-621fa8cc64e6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nachiket Patel MDPA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b2cf1c2c-a7b5-473b-8c37-e405a6e7bbb7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cure Cardiovascular Consultants, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b325db1e-d278-48b7-aa98-97fb6faadab8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "T-Mobile",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b363650e-9d3c-47f1-8011-4943dcc79def/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gulfshore Concierge Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b428538a-637c-48b7-b539-ff9e23bd629f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Advanced Skin and Mohs Surgery Center, SC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b438bc62-3485-4cac-8230-6d587898797b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pulmonary and Critical Care Specialists of Princeton, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b4fc8c7a-4685-46ad-866e-a6b49b921c08/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ellinwood District Hospital and Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b578459b-7bee-4adb-9713-0cef1d841bee/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Missouri Cancer Associates, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b61b0e89-adcf-4d35-8153-8c055ce48a52/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "West Tennessee Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b673e6c7-c87b-498f-86b2-99b24c52c924/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Michael J. Everoski, M.D., P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b69fa4dd-a04c-4304-b660-7554d71b5970/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Holland Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b7350dfb-b26c-45d0-a644-be758c7d66ad/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Grisell Memorial Hospital District #1",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b7d97c24-76cc-4a74-827a-3cd7c83065ba/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southview Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b7fee4ea-79bc-41bc-ae6c-4d9cef251670/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Menninger Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b8b96c9f-ac27-4b9e-954e-4833a13f19d5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Maria Fernandez",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b96617cd-e9a9-4deb-8d02-58e8c5cb1ed6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Brian Harkins MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ba40796e-8707-4090-9556-3c8b839b86b5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Eric Fontenot, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ba8bce9c-529e-4c80-844b-1ca88f89a8bf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Foot Specialists of Greater Cincinnati",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bb0f3815-61cd-44f3-85f8-eeb2e99ef22a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hereford Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bbbbf2b2-cfef-49ba-b1d3-f1f87b5e9013/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pedro P. Llaneza, MD, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bc1213be-2063-4c75-b0c0-c9285ec4abac/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pulmonary, Allergy, Critical Care and Sleep Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bc71e42e-6e3a-4ef9-a8b0-54cac01ec656/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jay A. Levin, MD, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bd05c5b1-188e-4fdd-808f-1d6e5be95377/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Eye Vision International",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bda8206b-2b36-455e-b305-1bae21f5b548/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Osborne County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bda9c6b4-e0b0-49ed-9423-c0c3e2ff982a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jasper Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bdbd4616-e8ad-4c16-a1c5-42c7683bcd27/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cardiovascular Specialist, Inc., P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bdd61ccd-8502-4f34-8f72-a5af1c755ae0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "ENT and Allergy Center PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bde9959c-b44e-4698-a1d4-e1ee4cc98a86/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bosque County Hospital District DBA Goodall-Witcher Hospita",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bdec8271-a893-4107-ba66-c0b4272fe522/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Western Missouri Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/be23e9e1-90d2-4a37-b049-059a92ffad6d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bay Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bea62b1d-5b0c-4c1a-bdbd-eaa129312421/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Intermountain Healthcare Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bec2533f-556b-4412-813d-c5ad8dc7a1e3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Primary Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bee4e7d6-454c-40de-9abd-9e2eb1cc9600/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Baptist Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bef96e27-b3e6-4b62-ab3e-78a9a16c8040/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Anthony Vasile, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bf28f0a0-d643-4b62-bbfa-515a5b632b83/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Scotland Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bf2bc40a-17cb-4353-8de2-68c75c849bc8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tri City Pulmonary Medical Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bf3cdcd1-e78b-4f0f-b435-3106b60f9492/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Berkely Family Medicine Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bf5eb65c-cdc6-4156-8349-5fcd9a13f4a2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bartlett Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bf776917-595e-44b4-b6c1-38106e126640/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Children's Skin Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bf8f05ba-6e12-4216-9197-5290cecb808c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Providence Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bf97af92-8bdf-44b3-b6ce-a415e2d7e017/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Peachtree Nephrology, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c063783f-c1a8-47a6-bf5b-d87d5981e7cb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Smith County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c0c316ba-6c8e-4f8d-898b-bb21c58aa05f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Medical health center of Middletown, INC.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c0c965cf-92cd-4218-9112-e865b2347771/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Saleem Husain, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c14a6098-afeb-4e0c-bf3a-408fab49f73e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Johns Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c1a92d40-9e4c-42a9-a69d-27d782800e16/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pediatrix Medical Group of FL, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c27de2ed-48d8-4303-8e9b-4f2faf8e4ea6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Inspira Medical Center Woodbury, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c2a40efd-16d2-4828-be53-a20ad0090e09/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "MedStar Health Hosted Environment",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c2a9aaad-29f4-4d5d-87b0-388c13a9b433/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sharp HealthCare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c2b12ebc-1d0f-4d73-b823-320cb1395bb5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Munson Healthcare Charlevoix Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c2zKUJGtYfzLNz84SXqRj8NdAMFQCK1P/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fitzgibbon Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c30ce58a-2367-49b7-9f61-141cafe7a3eb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Atrium Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c32cb33f-ec61-4f25-9140-0b9b174fe4db/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Greater Salem Family Footcare Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c3T6PEIfPZoUF9gf3uvco_NB4kf7fIWo/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Allergy & Asthma Assoc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c3d6a188-86bd-4e90-a26d-5bfd89cb9cd7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wilkes Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c3fd4b2e-3df5-4463-9a73-d51db35baf91/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Monroe County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c4077300-4993-4503-8ecf-1bd837357695/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Georgia Center for Women",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c4a6a212-76d6-464f-ba2c-c6e11ea9c530/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Celebration Minimally Invasive Spine Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c4f78536-22cf-4253-bd59-727d2da9d3dc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The East Alabama Health Care Authority",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c5013bf3-ebba-4bda-8574-ed83da9e1633/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Olson Memorial Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c5259d19-f4df-485f-85ba-303153b1ff25/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Massachusetts Institute of Technology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c5cd8f23-ae54-4fcb-84cc-92eea9354e2b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hospital Dist #6 of Harper County",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c63e0ebe-63f4-43e1-a630-b2adca03ff23/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. William J Hicks",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c75536dc-dc0f-4d24-99bf-fa4c77623097/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Community Pulmonary Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c7797114-dad6-4d8b-8399-0e9448563368/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Iglesias Medical Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c7d64ae9-fd64-4f4f-859d-299415240ffc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "City of Lenexa KS",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c8195850-d43d-46f4-bc2c-43fec4b8b989/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bryce Beseth",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c884454b-a4fd-4744-9d6a-4bee42b3e7fa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Knoxville Hospitals & Clinics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c8a72a6e-62c3-45d0-9495-592759355e6a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Miller County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c8e98568-c4c1-4ca8-9ccd-db28e9b32c4a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lexington Regional Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c90f55a1-9dfe-4440-9b93-7346ef821f3b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neurology Center of East Alabama",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c9412242-3040-4b44-a832-9e0c2378c87d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Primary Care Professionals",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c99a2c68-ceff-41e7-a9fb-11e1e806ec3a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "NewYork-Presbyterian Brooklyn Methodist Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cFBfzd-nLQ_NltNZvtkZioY0NCqOE2kf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Carolina Vascular",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cGr6mCA1DbzMHHPoXdGLeAeuLqt6f0Ks/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Navicent Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cPXkxGWnH-HHwThIezCJp4EJYz7iHU2Y/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Milwaukee Foot Specialists",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cQCyYza_NNRL3fDPuYBFegoP-zJkDNOr/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ibrahim H Amjad MD FACS",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c_GakPKBwGEp9LXRCx-dgLzSCTzRDPZ4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Midwest Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/caa256dd-47f1-49dc-8288-dfc601f2ffbb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Milford Family Practice",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cb26dc6a-db71-4f37-8be5-40b61109757b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Satanta District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cbeeaf3b-295c-4ed3-bee9-82bd88557832/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nebraska Foot and Ankle PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cc2a26ba-74cf-4fec-a5d2-d806d101d413/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UHS of Delaware, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ccc9af17-4ec5-4dee-8735-97dd2f249def/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mt. Ascutney Hospital & Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cccde49a-ee51-4ec8-9936-cc3836c11c2a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Texas Children's Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cd0af118-6cf4-4017-b601-b5e761f852f2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Whiteville Eye Associates, P.A.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cd0e7390-249a-4a9b-90a3-cd8f40025a49/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Luke's Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ce02d798-0df3-49b1-b868-83babab6d7e6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Midland Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ce473a90-8f1a-4986-bfd2-44af80062115/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Maryland Live! Casino",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ce7022a6-97a9-4e1d-a690-ced5152ae1da/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Creek Nation Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cecd1e64-dce0-42d7-821c-54ece9b4bad8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hawaii Health Systems Corp.-Kauai Region",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cf1fd70b-ce58-46c2-8a48-b5fabf717168/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Leslie C. Norman, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cf64663f-bdef-4b1d-a35b-95627bc92438/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Francisco Martinez, MD PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cfba5949-af14-421b-84cb-50f19cad7661/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ricardo Cigarroa, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cfe0cbb7-718e-4bd6-83ee-6633504bbad2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Vicki Raab, M.D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cps3xefvhcSt0AY7eotQvR92zVwh8r6g/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Circle Health, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d04f75c7-2a62-4686-b520-7bf0635f38f0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Clem Kirkland MD Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d0508ba4-12ca-4d49-861f-67d2a6a27066/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "United Medical LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d0607508-3922-4bbc-924a-d608b5ffe3b7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Plumas District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d09b5303-02b3-4cca-b4b2-ddf355d54e88/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "PAMI",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d13cd954-ca68-4a08-a95d-1ae54e7487f0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Memorial Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d14690d6-3018-4bc8-945e-f3e2f9884f7f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Agnesian Health Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d14b0ff0-3798-4e37-95e0-56baad6a5edc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Convenient Care Family Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d178af2b-123e-4a0a-98a1-88f04fb5a18d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fisher-Titus Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d1e1772a-df16-459e-9e9d-ac11507ad967/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Spring ENT, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d20e093f-31a9-4605-82c5-86f95f98be05/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "San Juan Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d2bc3d5a-3c39-4553-86b1-b3aa0a5429a7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Celebration Foot and Ankle Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d4005c17-185b-4cb4-bca7-c5c6e6a820d3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fillmore County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d4036e7f-af75-4bea-9808-6df2d5355c9c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Johnson Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d4279a55-0a99-43d7-81b9-5e54f94665c6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Moundview Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d4f9e3fa-7388-47bf-b87f-9c8679219c91/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "George L. Mee Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d520cb3f-b7f8-4cdd-842c-667f4e1d6459/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pediatric Pulmonology of Central Georgia, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d56d19c5-1f59-4682-8c35-bc6d80287bb8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Conway Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d5d04c85-2e0a-49b7-a0e9-5d5feaebb4a4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Shepherd's Hope",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d60ebf1e-4f43-4ee3-aa8d-81eddc9a9b5d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Madison Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d61ab3e4-55bb-4859-99e6-22c413b48f2a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Munson Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d63001e8-2b2d-46b2-9b8b-4bc37428b829/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gregg Harris, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d65aae46-5133-440d-81d0-4cf7c38d4aec/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Clarksville General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d69c780f-461b-4442-b8bc-95e38f92760c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Basim Z. Abdelkarim, MD Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d6d1b112-9099-4ef4-a649-a1adf35b40e6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Charles Schlosser",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d70f3182-cccd-4885-a851-68a653a0125b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hansen Family Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d792478d-c7a5-4028-84d0-ae569d6b0c53/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Too Tall Doc's, P.A.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d7b2ef3a-7b20-4ec5-af14-9c525d5c485d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sheridan Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d7c7003a-96ae-4246-aaaa-19b18f13056e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Rafael Abreu",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d802373d-49ea-4d93-af84-022b330fd6e1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dean Bright, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d8054bdb-86d4-407b-be85-631802b56471/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Essex Women's Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d80c61f8-55e9-4f03-aac2-d990f2ee9aa9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northside Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d88010de-d791-42d4-b72d-513f9afc5ed1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pediatrics at Oyster Point LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d885e14c-8eac-4d07-896e-861d8309023d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Kermani",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d8a66cd8-2aa3-4c46-bd99-c97f0bd810bf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "StatCare Outpatient",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d924d991-43c4-4c48-b322-4525ba4c2001/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Crawford Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d97362bf-37fe-407d-8a05-be96ba9615b1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rogers Memorial Hospital Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d9c821ad-f606-4b46-ae24-763b32cdc289/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Anuva Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d9d6c818-9b40-4c9f-8171-72c8c7a8d62d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Brattleboro Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d9dc001d-1bc5-42f9-bd4d-eb79208fd32a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "David Hamilos, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dBicsLkd3XVQrgQlh28QIWbKwqoho4uN/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AdventHealth Orlando",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dHaVtZLgvu5YOlvLMlo9dsb8VzSVTZDK/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "UHS of Delaware, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/da0b5d99-573c-4f5e-aaf6-8d39fa93d033/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Charles Murphy, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/da2180c9-bd45-4fd0-aaf0-2b4abda5475d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cogdell Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/da594151-329c-4768-a26a-5c6b74be997b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tuality Physicians, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dab37ab4-940f-46d2-83dd-9830ab97c4d5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Western Connecticut Health Network",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/db9c2801-7026-47b6-a85f-5d485070d969/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Community Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dc5473f2-b01f-4963-a3d8-5474b2d33b20/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Advantage Healthcare For Women",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dc96a33f-fb3c-4ad3-8d24-0941136c69c8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Paul Greco, M.D., Concierge Medical Services, P.L.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dca1cfb3-683c-4835-9b66-95a129c0bbc2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wyoming Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dcf3b1c6-3971-4673-962e-8b2cce0ff827/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mitchell T. Zimmel, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dd839e2d-c171-46e8-bad2-f7adc1f055dd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Westmoreland & Arnold, MD, PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/defbea08-f7c0-41b2-bfd7-5c64c68d3dd5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Steve Lovelady MD LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/df01cf33-b6d1-4222-ab6f-d5b35ecdd012/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Neal Suares",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/df0ee526-959a-4abd-bc92-e5a1c513a0cb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "New York Presbyterian/Hudson Valley Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dfc83f55-7737-42dd-8c24-78fcd11bb8fc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pontiac Trail Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e0342657-8ab8-42a7-b0b2-df2a49fa7eb9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kingfisher Family Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e0aed929-e53b-4d96-a40c-36cb9539f12f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Orthopaedic Institute for Children",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e0af8ad8-b54e-46fe-a442-6f887f68ff27/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "State of Kansas",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e13c1e21-bd04-471c-b46a-cb74f87dcaaa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Internal Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e1517302-aa9f-41f1-ba0a-8919fe6c6001/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Yvel P. Moreau M.D",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e1cd2646-a978-48a1-b1dd-27086f7bcfa4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rockland Thoracic Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e2ad55a9-c891-4848-8484-9308538693a3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lake Region Healthcare Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e35355ac-dfca-48b9-9dd9-0b7c408c2a66/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "PAMI",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e38cae97-dc5c-44e2-8dda-ca848530d8cd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Green Valley Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e3c3f29b-49ce-4329-ade7-4c5593d87595/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mid-America Internal Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e3f39aec-5b1f-4457-b1e5-9098a4b10cae/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hillsboro Gastroenterology P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e472be88-5795-469f-aa11-18b9f51c16f8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mon Health Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e4a5b337-4c87-45bf-ab09-077b7fc19e84/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Johnny Arruda MD INC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e4ed3cc1-426d-4144-a9f2-f9eab264d97b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hazelden Betty Ford Foundation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e54ca37d-332e-47f6-85c8-4b653eedbcbc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Methodist Fremont Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e5aae69e-9f28-441b-b336-7e38e089fe2b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AbbVie Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e5c7a150-047a-4c41-88cf-7d5d78afaeea/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "New York Hotel Trades Council and Hotel Association of New York City, Inc. Health Benefits Fund",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e60dd76f-2355-47fe-85cf-f04cc40e0a16/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Donald Huang",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e6567e17-7548-4791-8688-4e41c1c041ad/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Chase County Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e699c25a-4b9f-4771-9576-e790a1116e0f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Upstate Podiatry Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e69c2bef-d9f0-4b8f-8ad3-47f8715149b1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Associates In Gastroenterology, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e6a2c484-1066-4f3f-be44-cc7c2a79d6c3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Keck Medicine of USC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e6f9b4bf-142e-47be-8246-33cebe5229b6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Grace Cottage Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e7974a89-7cd2-4b5f-95db-82e9a908402d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tender Care Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e7eee8ee-10a0-491b-8be6-a8be12c18675/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Faulkton Area Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e7f1db76-681a-46a3-9951-b0b343a47d69/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Franklin General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e84122bd-f46f-49c7-bf07-41bc9eda3960/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nebraska Cardiac Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e8483750-562b-433d-9f50-10942f0fbd4f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Benewah Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e8b4f872-6ea1-4b26-a974-041b5fb4c57b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Avinash Gupta, MD, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/eME9di7OkJfK0Dd-1ZlVnxRWlL5I7oU5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Womens Choice Oncology PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ea87e17a-d61e-4405-a8d8-e999d9a648b3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Columbus Pain Center, P.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/eab031dc-b014-4e04-af2a-409cb0a42bac/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Henry A. Pretus, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/eab0e7ae-9234-494a-b931-951d942d180e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Walter Knox Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/eb237299-e2be-4fd4-aca6-5fa7adcd28c1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Spectrum Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ebc46185-d254-4127-aaac-ce969218157e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Catherine Chiodo DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ec02c4f4-91a2-412a-bcbb-74b4b09ac019/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Marcus Lee, M.D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ec6b7097-8351-4185-ba79-b9f0c80b045f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Humane Center for Arthritis and Rheumatism",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ecb0768b-f462-488f-a03b-0c40f4d77fbb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tomeka Roberts, MD, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/eccb6e09-c137-4463-964b-10c8a4da7c61/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Stacy Frankel MD PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ece3b0d0-e9d1-4d87-8810-05245549aaf1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Center for Healthcare Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ed1470d0-1564-4ba1-8319-621c7811cd60/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "PAMI",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ed1a6436-bdd3-4803-83f1-a24346db7ed7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "United Surgical Partners International",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ed29dd2e-7f6b-4b48-93ba-6ba78c79cd2d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Michigan Institute for Interventional Pain",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ed6140a2-373e-4f70-84aa-c25e94497b9f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sabetha Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ed8a62d9-e900-4503-b1c6-0e092e2ef12a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Hospital of Central Connecticut",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ed8d75e5-e406-4ba4-8ab5-2d4dda194818/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Su and Chang Dermatology Associates, APMC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ee3151e0-eab6-428c-81ce-718262289f98/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Aveon Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ee4e5494-2c92-4d67-a270-fa42d8538b42/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "TMH Physician Partners",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ee8aa586-4745-4cbd-ac14-f90bc6a4297e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bay Area Neurology Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/eec17e06-5076-4883-be29-b48c65a8fc07/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Operating Engineers Local 101 Health and Welfare Fund",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ef0bf930-6b2b-4701-ae80-fb69fe6af070/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cheyenne County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ef894d13-ce69-42f0-bfe5-f1607027bc20/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nebraska Orthopaedic Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/efffdd49-80a8-4c46-87e6-e53d54707ef3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tri-City Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/el-cOzZz2taXiCUnZcX6Aeuou4gpZkX2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jersey Rehab, P.A.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f0cfd11a-8550-4ab1-abda-1200b8b852fa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Uintah Basin Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f11b499f-f009-416a-ba91-79d8b37ce81a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kishwar Shareef MD, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f16ab50d-5d7f-40fe-8c31-87d7133c9e42/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fairfield Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f17aed19-e2f6-49d4-bba0-64508a2357d2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Henry County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f1bb4645-ebf5-4d16-800a-fd209b7f9cb1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "James C. Crittenden, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f2435108-6ac5-4b8c-a0fd-046ed852f786/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "James Fierro, DO",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f2e24f7b-9e64-4332-8401-3c349ad6c7fb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jason Defrancis,MD, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f2f8af61-ce86-434e-9d4f-b09a982ce734/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Alabama Medicine and Rheumatology, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f342f1fe-7dbf-445a-81a0-f5820c7e8814/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Beloit Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f4477d7c-dbb4-4046-92c9-1cc56c248ecb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Columbia Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f4f5fc7f-b635-4b26-8ba6-058ca1c8dc4d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Timothy J. Graham, D.P.M.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f52e395b-cb40-4c80-96f8-ef6241b5512c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jupiter Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f5c2ab60-651e-4c3b-8f81-7ac7322f77b0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tanveer Ahmad MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f65dbd8b-ab9d-477a-9002-1607571da950/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cleveland Area Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f686027e-6665-41bf-82f5-c9d2a9f004d7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Eastern Medical Specialists PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f6960be4-ec5f-4de6-8b4b-e2f3c6a9bd30/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Delaware Foot & Ankle Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f6b3438e-050c-4890-a29f-e0ac33bb956c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Centene Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f6ee9d18-ffc2-4889-9056-9398524e1476/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Huntsville Podiatry Center, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f6fa7381-903b-4783-8911-188a44e03a3f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Adventist HealthCare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f71725f4-8a5d-45dc-9e68-6ddbc583dfb3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jaisohn Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f749ac8e-846a-4185-aba6-92d85a38f519/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Christina Goodridge MD, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f7b34135-f483-4274-a0f0-9aa8d656a86f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Susan Hunter-Joerns, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f7ee1b9a-ee95-47a7-b4a5-4902951fcb85/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Adair County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f904b187-16a4-4582-8ea3-887d87de0011/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dallas Center Medical",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f921a378-be2d-4c05-908f-c400501abbd0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Your Next Step, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f94c51a0-56e8-4b6b-b7fc-444d2a37a178/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neighborhood Health Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f95f1525-0f2e-4884-bae5-8f36736ae7b1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Advanced Pediatric Care Ltd.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f99feffa-a04a-4042-9325-6ec22532618b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Radiology Associates of South Florida",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f9aed9f4-5c6e-4527-8cf9-3a241a404968/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Brian Weeks, MD Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f9f2e2ba-3339-41a9-9c68-c52b1c13921e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Peak Vision Eye Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fa0f517f-db34-4a7a-98d2-758b513b2168/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kennrick J. Dennis, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/faa53cfe-86c4-4c37-b87e-a425abe8cc46/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Boulder City Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fab57722-243a-4069-b32a-bcc74c7779f7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Tricia Hislop-Chestnut",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fad27769-c4c9-439b-8aeb-2f16c753ac96/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Children's Urology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fb1a9a08-013f-4e81-9e96-ab9b9040386e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Texas Infectious Diseases Consultants, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fb7b0281-6ccf-430e-a59f-d7e9d3834a96/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Allergy & Asthma Clinic of Alexandria",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fbc8c866-997f-48a9-94e2-a511f307192d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ellsworth County Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fca01075-736c-4da3-b816-2ead95b5dce5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Huntsville Hospital Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fca878a1-6c97-4ecb-b6e7-eb5d7cde15ab/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neil S. Ozer, MD., Pa.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fd185037-bf1a-4d86-8438-6657be53ce04/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Independence Park Medical Servs.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fdbc9673-c618-4425-b458-9d4512be1bb3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gastro Pediatric Partners",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fdbebc86-839d-40a6-a52c-f292220e6f36/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "CommonSpirit Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fdqklJrzTg5-JsHjn6gcvJbZmmigMGfd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Joel Frankel MD PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ff12e4c4-d870-4293-8118-95d9d426fb5d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dewitt Hospital and Nursing Home",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ff3e5cd9-c23e-4fa5-b77d-dca4a39aa946/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southern Maryland Electric Coop, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ffda347f-dd5c-4ddb-8491-9dc707da579f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Children's Hospital Los Angeles",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fjycTxieSBez9BFs-LP0YIikqnvefkZc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/gF4lFO34tdbrCuznA3JTeuZ_9C_vRKZf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Chelmsford Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/gNshjM5O9NNHo91poBY-hsv5tXiOvke8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Foot & Ankle Clinic LLP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/gOP4994uTxKCP3l4vJ7Jqo6k1NZgHGsz/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Shirley Ryan AbilityLab",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/gQLsUwK-sX1j_JHv5H2t4FlFphw_xyX9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jeffrey W. Watson, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/gVhfMvu-XwQRgQosgHcm4vmauyjhpt-k/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Center For Reproductive Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/gc3D2uUK9_wiMPvEUVjpk1l2BlYpBT7b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Middlebrook Family Physicians, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/gec4dOg2yghesFrkYuCFDQ-HfVUq5AqK/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rockland Thoracic Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/gzygYmj_ixxj0K8SMYuNLmEP8OHSt4DS/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Winona Health Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/h-wugRRmXDZkm9_GMtf9rhlhb3aHTbV5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "William Hansen, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/h2eGtPVeNW7cIXpao1aZHtpUU8ww6GX1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Anthony Parks, M.D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/h3vXgKcy9xzmARVPPGTm-aPdZWF6hpS3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Olson Memorial Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/h7Ihx8KqeFMoV6aVE3v7wQPvUnR9Dqw0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "White Sands Family Practice Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/h9KqHATFapnAh9QYI0aR69I-qK5X4t_N/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Surgical Specialists of BG",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/hC_P1yFthbfDga3D5waD8G-f6rVln_Bw/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jason Amato, MD Dermatology LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/hHhBZnqD5ZnFB3frpd36dudKBHu6EKvB/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "James Brungo, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/hRl8JDuP-2CULrcrMMdYM6D-1ltmi-Hy/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Enrique Griego, M.D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/hf5J5V1F8weuXDjNzKXwtL9Iyl3y33_0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Professional Associates in Surgery, LLP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/hk3a_n9kE2iADMEcT-8aONHluTmOxrTW/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Marlette Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/i-zcCbJ35X2O5bJkqEF8dvUIAeQf3o9y/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Metuchen Cardio Associates, P.A.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/i5Jn6dkai40kwQ-Ttd6yts8LatmIDujZ/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "LMH Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/iNB6hL-tYJggf7je2gx1HftngxiOxAQ3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Columbia St. Mary's, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/idzZ7Xu4K4e6cf6O6PqH5zcqaSD8_vYU/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Health Consulting Systems Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ig2DLlD17G46NZ2TvhplBaJjVsPDHARg/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Grace OB/GYN",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/j1IyQmGp5_V_WwI9QPYQIpekJfKTa5u7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Amanda Meszaros, DPM, FACFAS",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/kM_99Orj1Rg3wRNHtR8VeEA5tc_onQVr/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Medical Center Podiatry PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/kRYst33szaxuWCcieqasTJv68zF9577y/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Advanced Foot & Ankle Clinic, LLP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/kSfiRTuNDYx_39U4kLLwpT-2wyiW22lf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Borgess Health Alliance",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/l0sV4kAP8XYUeDPWgsblj-f2yztSg0Ya/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southern Internal Medicine LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/lKCPDiQgazoGE3paP2y6xrcZ5A3i0bDn/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Thomas Rich, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/lKtfa5-PPcTSlw3G84vjcA2C5nRSdCGY/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Juan J Salazar MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/lPF6Nmtsq7QZn3Z4mj6UwIY-rfDIdNIc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wood County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/m6q718FZg_-IH-imjhHk1P9jJGSwQzGK/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Aultman Health Foundation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/mP6IHJrv4n0_mPZFBm5GcbTX3TNMQJqa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. John Providence Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/mQjCqHb5rkr1u1foU4dqhQPBpi7Qk9R4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Southwest Foot & Ankle Center, PLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/mX7hxwEYErARs9T3I5uOZJg78CvtCjXk/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dan Bangart, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/mXy5ruQtMW3KrdcgJMyfKw06O9IkfnI0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Holzhauer, James L., MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/mobVwSb4vMbufrug1PluiBGFLGTxiUMQ/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Solano Kidney Care, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/mpHeoGaxK5S85g1wJYZSJQd5Cv8j4Vx4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tod S. Reed, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/n-IthgIyDeEmqX148ukfLpw4d7XKXejt/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Chestertown Cardiology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/nI1GEqv2GptXSzP6SLPD5eHiyiISgxr0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pensacola Foot & Ankle Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/nf8U42ELfecnNzeE3KFMRXwJoUOMBep7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wray Community District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ntTIZxOIDS2tB2PUqr33FYQo0UWd2W9R/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Canyon Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/o5pd3b6-cuxAhiQtysTRpegXDGjPAEUV/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pine Street Podiatry",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/oftb6hxIHnNtZxMiREGYvNaJbaPmNQ7p/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Emmanuel Emelle, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/otCmFR9xLPoc2YGLoEEuj1ulH3uzON_F/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Neurological Associates of St. Paul, Na",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/p84Vhuk4mPWFXFbQg94FgStyyPbRtG_D/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rio Grande Heart Specialists",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/pfPtWFyx8DThC8Zai2vpgBwaBZV28KWi/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Hussain Al-darsani, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/q-3vUFaQmB_tKrR0ZIC4Z4u1bJnjsSJr/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "D.V. Pasupuleti, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/qAVEa7m1IQ-JEiYJqzzgxOEBv0A3Rmhs/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dublin Womens Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/qJCdeykC_0FoLWOQ15eYFbhjDQNwFiDg/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Amador Hormilla, M.D.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/qSQQl2ShxAvRHD2W70uxQVtT7BNMIXXO/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Naples Premier Concierge, P.L.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/qxwleH164DZXpWMqxaJrMbQUqnnRWJfq/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Center for Manual Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/r2GtnbpYK4vtuAbMjau8TiI_I1r8CPyN/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "NCH Healthcare System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/rbydrzVcVSCNsdQAe12aQKnP6ZixR1Uf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northern Light Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/rii-5tqZIeHcg01uWOcN3lATP151-1Q9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Scituate Podiatry Group, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/sbZmqu_ebJfkW97fOWCec4QJKCw6sjcW/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mercedes Medical Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/slYc7WiVO_dzl3tGHo9GBCymITDhz-sg/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "A Woman's Place, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/sqiH60CNKO9o0PByEO9XAxX0dZX5s5b2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Rodrigo Argenal MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/sw4tW_HCNxON0WgWbRHaakuPPu_xXIN6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Penndoc Foot & Ankle Center LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/t0FnDeiv5UB5yBJtCG5ByjAAa3LXYuNV/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Vibrant Health Family Clinics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/tQB5_7uQVbVZScakpLQEzBwfBS_4PTHH/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gastro-Intestinal Consultants of Manhattan, P.A.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/tSoPH8IMQuFTAj8CJZrbUMvKrv1i9WlM/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Podiatry Foot and Ankle Care, PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/tW68ZW-Hmy7Lzce-ns8ohuxjCYcMJFzU/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Thomas J. Hagan, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/u6U0gXkDqjtHVjydWZoD3S2kqgtUZm30/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mosaic Life Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/uBptauhAUxqfDlGzLHbgg1dmomcdTBGI/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Clifton H. Hunt, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/uLr5PM8gMPeZJe56FDmfjobJ6FGjEMEk/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Larry Campoli, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/uOQzJcWKhFvl4J-SfFSpaG622G8TwRPZ/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Morgan Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/v561Je5dfmji-4BVw-9Mkp1hj_V8JdmU/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ashland Mansfield Foot & Ankle Specialist",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/v7_ZWNDo44D5rdNkeMtK4_1va3H09PQq/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Associates in Otolaryngology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/vHLmhTUEuZU9-C7EaUC6GMW9dKqEQxFt/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Alexius M. Bishop, M.D., P.S.C.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/vvWOESzbUe72lEl5ItnHhnlfe3uimw2P/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Colonial Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/wZCgH1CWyIXU4RnwCSTNxxMaI62WkSe4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Deer Chase Medical Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/wrew10vD3jepzbTifdu3IylT2gxN5jJt/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dover Foot Specialty Center, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/xCzjlohQb7LjffswhVfzHuvSjTl4Y9sP/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bitterroot Health - Daly Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/xGC8us00w6i72tkLoWiE0pdWD5WWsJe5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tey Women's Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/xV4nbZGmDts5h0cW_qqdfyysQaM9g4Uc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "RWJBarnabas Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/xYxhuXIFsLg59PaSNJv_x-piAtPKX3W8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jeffrey A. Fischer, DPM",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/xsi8i2IV7_2GY-SfeLLZ0w2vRcPnO9Sk/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Health Consulting Systems Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/yM1TVbA1pYVBqAL5r6hrPXGVr5nFBJbP/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Affiliated Podiatrists, Ltd.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/yNokLJokA2wmiV0j4EDnXS-uMoIhGKVB/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Detroit Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ynC9J_dODQE9MboiEOzSXwBNhdrTWHFe/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Marble Valley Healthworks, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/zA015PZlU6y4mS2M66rhwFskWFFyp2EA/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Klass & Wasserman, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/zQbuaOz8Rb6ie3Ivt6H_LeKnU4TVuNuA/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Genesis Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/zRBZsbKdoME7HivKpjAL4ZEb8JQBD9Cn/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr. Chad Smoker MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/zf0glaGG5hLhMMZqeh2-kRj3FD2n6MNs/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Labcorp Employer Services, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f46fd284-25a5-4e25-8001-24f94182ac13/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Community Medical Center-Missoula",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/57e9b20b-351b-4b85-8ec7-ce273f1da74c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bhavesh Patel",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3fe60ded-faad-4fdb-aaa0-2885c5eec160/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Geisinger Health Plan",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0c462397-70eb-4c62-9e7b-172ae734b283/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Salina Surgical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d29c89d3-f6e3-483d-8d3d-4a628849f568/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hutchinson Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4b9f5490-74cd-4f99-afff-f874348363bf/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Spectrum Human Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/704a1319-18d8-48a8-90a4-1ca0fbc05de6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blue Ridge Behavioral Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2ff6a8d5-57b7-42f5-afd5-bfc08b37bd8f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Remi Vista, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e917cccf-ef86-42c5-a988-a3b636c7a1c6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jackson Parish Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/21ed112e-ec5e-43b1-8ddc-cd3753841e6e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Washington Regional Medical System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3768b58f-9087-4dfa-842c-2b8faa633af3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mid-Valley Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2f4c5ffc-f00d-4f5a-b6ca-21795d2aa680/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Butler County Health Care Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/92c98ce4-86aa-46dd-ad49-f999f20da53c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Humboldt General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/84057439-c01a-4bda-b31b-652cf17a67ad/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "CHCC Medical Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/47b1c0d3-481a-4b04-b2c8-b105e0d45af5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Permian Women's Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/abd8726a-ad55-4f85-8206-9ee9deb6ac7b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Olean Medical Practice PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6edd93a1-7391-4938-bcd9-ebe248fd573e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wheatland Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dfbeeaa4-1e66-46f8-8cd2-e9e16e1690cd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Schoolcraft Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/71812193-7aa5-42d8-ba4c-ee45e2ea853f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Eastland Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4dfa8a9b-1737-4e29-9540-cdf160fd93d1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Seasons Center for Community Mental Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ed13fa1e-5e6c-45da-822a-ab9435740c2e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fernandes Banerjee Shenoy Kidney Center LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/164776a0-ef92-46b0-b574-bc0e63ed9671/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ashland Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/95fb61bf-febe-40ea-9e3b-6043dff13427/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Colonial Behavioral Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2b8c86f5-c497-45b0-94ed-0102e20d1c70/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Children's Hospital of The King's Daughters, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/237789e0-8b40-4355-aefd-25694ca16391/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Westchester Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0e5efebe-b60c-458e-971a-ee39e08a2178/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Geisinger System Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ce6a2fd7-f060-478f-8ee9-1a471e2d7398/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Geisinger Health Plan",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6b6ec52f-679d-4556-8bdc-6f257a573307/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AtlantiCare Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7ab285c0-fca7-400d-b78e-f861ffccdcf2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Geisinger Health Plan",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bcdc74b0-4e5b-45db-9272-627ece27743d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Suburban Pulmonary Medicine",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2b76d21c-b20a-42c8-bad0-54a58e0ed059/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pawhuska Hospital Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2132e612-090e-4a56-824f-f9183e251b6d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kiowa District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/18873135-3bbb-44c9-950a-a010c0269f4b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Macon Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7b9c3187-d5a9-4f6c-ab6d-6c3b4f2632bc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "New England Hernia Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5702a1ef-1ffa-4749-8a59-5b2ca3bf45eb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bacharach Institute for Rehabilitation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/15758d3c-e7f4-4df2-8236-c16c5a55011e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tri-City Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/124c0226-4a30-493e-919a-d360c6c85fa7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fairbanks Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d2e61489-9680-4a3d-974a-fc8d705fc283/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Winkler County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/77dc4f13-4542-4087-9840-c260ca5742e2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cumberland Mountain Community Services Board",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bf94e4d0-3a14-41fb-bd44-4abbe957f297/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Yuma District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c3e623e4-47c2-48c0-8c45-866563c97ee6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lake Health District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/91732642-b694-4776-bbd7-c7859cc968c4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sharp HealthCare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/994583e3-c777-4cf2-a61f-8a6fecc94ca6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Fedeli Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ebaa7f8d-2913-4d38-b066-a51feb0dbcd3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blue Cross Blue Shield of Massachusetts",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8a4e263e-358a-4295-8e47-8d82e9a6581a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Logansport Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/46286911-5e07-45f3-b3ed-613a98a13430/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Coastal Plain Community MHMR Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cbd4218b-836f-4885-9bb3-ad046fcc104f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jefferson Community Health & Life",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2b9c31ea-6ddc-4b55-946f-2c60cc32be99/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sturdy Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3518be8a-ee50-46dd-887a-a3e6e4fc9294/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "State of Delaware Health and Social Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/987954ae-9180-4ce0-afd9-4dd65628349b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lake County Behavioral Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/aced9196-1c22-4957-a2bf-6d7f15628440/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Fraser Child & Family Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7ae5effe-14dd-43c0-8dfe-a02dc2e1233f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dutchess County Department of Behavioral and Community Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3eaae75d-13f1-4578-a896-2c3cd494568d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Crossroads for Women, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a349a661-1153-4053-a40b-30cb284c6ffc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pipeline Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8d72d1d0-5e06-4c91-a553-c2a44e6b7fe5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Healthwise Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9719d5a9-c12c-45b7-aae3-501e08eb5252/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Endeavor Health Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f691d777-e7de-4ba5-bbc2-a5052e2f6912/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Henry Mayo MSO",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c65052a3-5b56-4bc7-9da4-b721aa72fb0c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kings View - Del Norte",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c6359e1c-cb28-41a4-8d79-4332ce30e322/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "American Century",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dc9cc670-c6ff-4240-acb5-59e5ad786041/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Capital Health System, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5bb47b8f-8587-42a0-80df-8d4eecf69db3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bridge Counseling Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f9a6475a-3dbd-47b2-979a-55064cfdbd51/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Horizon Health Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/78f4cdd4-55a7-4d47-b25a-4d044d550506/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "My Kidney Care, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0cf77109-e68f-4848-a530-1f53e0c2db32/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Prairie Ridge Integrated Behavioral Healthcare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/41ecb586-5808-40cb-b092-b484028fd321/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Internal Medicine LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c858c747-c492-4c80-b098-823abe48bb82/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Geisinger System Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7ab3d0ab-808d-451f-b0e3-d59dda3f72e5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blair Foot & Ankle",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/29bd7f74-505f-4da0-ab1b-2b3301332cd9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Children's Hospitals and Clinics of Minnesota",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ya_22VheLN-3mn5hR1J6QJ0Z8rMCHJ7F/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tri-County Mental Health Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b39fa050-f9bd-471d-b705-2049f60e1d46/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wilson Medical Center - Reese Campus",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6facadf3-e724-4db7-a26f-0449710dbd8a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rochester Rehabilitation Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7c4ed6b7-c140-41eb-bc5a-5ee81640f80d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "JOSEPH F. ROBERTS MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8ae75827-0f9b-457f-be6b-a17f2d896c19/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "US Wellness",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/045860c8-9feb-4ffe-98ee-d4c565e9bc9c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Touro University Medical Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e0d732aa-1d5c-42bf-b672-8fabe3feb437/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Three Crosses Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f0d5c852-07f4-485f-99fa-b042a7a7a20e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Delaware County Memorial Hospital dba Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8fdd186f-a014-47f3-8c9e-d61f95a9a6ea/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Association for Mental Health and Wellness",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/77c2b089-5ae8-473f-98a4-de9173e168aa/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Delaware Valley Health Trust",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b1ef87a9-8303-439c-bd5c-f767f2077a02/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "American Century",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/734b6633-3203-4245-887c-cd27c8dfcc93/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Montgomery County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2204183e-6c83-4c63-94c0-94d8c17a6ef8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hampton Roads Orthopaedics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/bed3d35e-3090-48a3-846e-89c1619e8fbd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "ClearSky Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ac2ef729-5b74-4f97-be5e-101a996a9360/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mental Health Resources, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/557d7750-391a-46cd-b368-48399c62b8b9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Central Health Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/cf58ffc5-3496-47e2-bf0d-3a926e61ae7d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Post Acute Recovery, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1c45401e-7295-4e0a-b527-889e5b1286bc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Los Angeles Jewish Home for the Aging",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c2f80014-27d0-4f96-88b1-b41e0034ba47/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Acenda, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5ac1e57b-e918-4133-bda2-dccfdc407094/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Catholic Charities Trenton",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3d9cd35a-d012-4d0a-9edd-67d1e56d2a64/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kings View Corporation",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e34bc0c3-72df-4049-b436-4546b26f4dd2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Denver Health Medical Plan, Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c11e1587-600c-49b6-b847-2ab314b9ee09/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Warren Washington Association for MH",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/10d65d12-0ecf-4613-84df-07c7c4f09ca4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "Douglas, Grant, Lincoln & Okanogan Counties Hospital District #6 d/b/a Coulee Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f18be9cb-2758-4a4b-a2a6-5e5131bfb5bc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hillsboro Ortho Grp, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a80e5974-f906-4d6f-8d3c-77165a60dc71/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "BestSelf Behavioral Health Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6e4def70-1dc1-4769-a067-b144af5e540a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lake Health District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/794039a8-89a5-42e7-a8af-b2a702849aea/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Clay Platte Family Medicine Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/032e9fee-d494-4ca3-97ce-b40c8d2eecf6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Johnson County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0abc5c50-19e6-4961-a76b-384f0caca068/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Odessa Memorial Healthcare Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6437d534-74f4-4c4d-974f-f529c9435777/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "ComPsych",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6afc702d-7c56-467a-aedf-49ea8677d023/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. Vincent's Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/71a7ae5c-fd06-4e97-9d52-1b2ec662d620/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Presbyterian Healthcare Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/67993c22-74d3-4e9f-ae4b-852b5775b754/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "The Steven A. Cohen Military Family Clinic at Aspire Health Partners",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/89aa3c8a-5af5-4166-add0-a8ea5eb1afec/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lafayette General Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c93f0ebd-007a-4296-b842-6ac2a4658eb9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Healthe Employer Clinic",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/28b635e9-1338-4104-a4e8-4056bb914688/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "DaVita Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3b23ba82-4045-4c42-b34e-b749fc14463d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pike County Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/89787a16-eaf7-491e-bab0-d804157796a5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "City of Chandler",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4211ccc0-df3c-4100-a077-f6b59ef3ddba/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "WellSpan Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/fd4bb206-9367-4644-b3c3-c1a6e26523f4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Community Health Network, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/84bad1c0-bbc4-4b69-8271-ee04c2b3f1a4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Livingston Hospital & Healthcare Services Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3979aec0-01c5-4867-872c-320311ff1822/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "LA Care Health Plan",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/46237eb2-e04c-402c-b972-0c5e128d1b5d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Huron Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/31fef104-c81e-4b2e-b1c2-a11a2b75de40/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "BayCare Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d92457a2-9607-45c0-987c-48523ea3242f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Premier Suburban Medical Group",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/53113a2f-ce08-426c-a627-1d944f724a9e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Montefiore Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c6612efa-63ce-4f4e-a3d7-9d31c013cadb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AtlantiCare Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c758d838-0983-4118-895c-525b7387b254/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sarah Bush Lincoln Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b60a46b6-a3df-4cb6-983c-dfcc9a0589e1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Baxter Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d9f82512-47ad-4066-b765-ea406cdcb2db/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Oklahoma Surgical Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/37d0fa6b-e0f7-4581-adbb-f9e2eac855e1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northern Maine Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7722ef4c-2455-48ad-a4fa-814cb1ac7718/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Total Body Pain Institute, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0b6b0303-cbdd-4ff9-91bf-eeb5a4c8911b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "AccelWELL, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e01b6c4b-db0a-457a-843c-c05296c77706/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blue Cross and Blue Shield of Vermont",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a57211fb-a053-48c3-9e4e-c2c4e7cd4f71/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "William R. Burden, MD, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e7b98fe9-c1c7-41df-9bd1-3564793164ce/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Namita Mohideen MD Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3b6634a9-9b43-4d04-9164-67830eddec34/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Cibola General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4d334a73-dc4a-445d-a950-509dd7bc0fd9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northern Inyo Healthcare District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2fc0be4f-8d9d-4f3f-89d9-ee59fb2aaa86/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Clay County Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/85e4e207-a7a6-47a1-8e35-8e04fe8019c4/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rockefeller University Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/70be2934-ad89-4799-aefd-32f31fb0f9ef/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Crystal Clinic Orthopaedic Center, LLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8a12d269-bbac-4647-8604-a4aa813b261a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Madison Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0875d958-ca57-4bf3-a3d1-8017bea319db/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Steven A. Cohen Military Family Clinic At Endeavors",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/351587b9-2bb4-44d5-9024-e475e0b7510e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Community First Health Plans",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/93e5ba5f-01b6-4ff8-aac2-2bc00f824e93/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Crockett Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b4348b5b-bd9c-4bea-a3a3-0691137fbf46/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Primary Care Specialists P.A.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c2c641c8-5233-4dab-bc71-a8eadb28e83d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Opelousas General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/840cfaf0-ce3e-493c-a182-e85f2fdef4ac/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "District Medical Group, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/75620b41-1ac4-4c73-abd7-1415dc6810c3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "St. James Parish Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/71db284b-f315-4638-addc-f58faa7c70f7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Steven A. Cohen Military Family Clinic At Veterans Village",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1c0a08f9-9cc4-4641-ba0f-c38d264c2529/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "Mountain View Child Care, Inc. d/b/a Totally Kids Rehabilitation Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1fec57aa-48c4-4598-a98f-f72022b4a4cc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bridges Medical Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ce3945bd-6cea-4e7f-8854-a7e8b58f614b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Effingham Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/210c1b9f-8bdc-4fc0-af1b-d0a64f9c307f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Haskell Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/58719a2f-ec28-4116-b1e7-a70dee5ac969/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hardin Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0276a61d-cfb3-486e-9665-b29201df0391/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Chadron Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d8abdf5e-a2d6-41b9-bff8-4f8bef8b37dd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Syracuse Area Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4c47f81f-d032-407c-bff2-76a77bc90bd3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rehoboth McKinley Christian Health Care Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7290ec87-8419-47fa-9f4c-2ce723e9fe8b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Centra Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c3bc972b-645a-4e0e-9727-2bbc1db34702/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Dr Anuradha Kollipara",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/eb20a6ef-52fb-42cb-a510-0a41e19f393a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Hermann Area District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f62890b5-77ff-44bd-a981-0a0981047b35/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "HealthSmart Care Management Solutions, LP",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4d80b0f4-782a-460f-b364-49ec173d8d2f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Providence Health & Services - Oregon",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/57956409-cd51-43ce-a57e-5c0de3d73983/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jackson Siegelbaum Gastroenterology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d3bf785e-3489-4660-82e7-681c3c1a77cd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mason General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ed3f5ef0-1e43-4472-a811-c1c95f23d109/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mission Pediatric Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/858b0c69-6e2c-49ec-82b4-fd8c90a5ba5c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wayne State University",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ad8ce5cb-076d-4b2f-a3c8-94b0574f0516/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blue Cross Blue Shield of Louisiana",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b6d93b41-a32b-4dd5-9e70-bf8701bff59e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blue Cross Blue Shield of Louisiana",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f7a07b30-b746-4472-9c87-ea9b751a3943/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Steven A. Cohen Military Family Clinic At Centerstone",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/11f5b60c-7ccb-45b6-9c17-e5bc03ab46bd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "The Steven A. Cohen Military Family Clinic At Alaska Behavioral Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/37729496-dd1e-4fc3-8c61-2567a329f99d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University of Tennessee Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/31d2d8ba-ab28-49e4-94d7-3800ca260736/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Greensboro Pediatricians",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d229eaa4-39ac-4ce1-9bf0-8c3742977a5b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Regional Medical Center of Orangeburg and Calhoun Counties",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0fba742b-eec1-4103-87e5-edbdf1fe1e30/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Memorial Hospital of Sweetwater County",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/82c1b592-2342-43bd-a292-07e36f400517/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Eminent Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6a5c785f-c1ec-46b8-a0ea-6498bdab016c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "MultiCare Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8b053a4e-d04f-420f-b772-45b3551bdda7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "T.J. Regional Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/24e03c9a-e2fd-45f4-8243-e38cc7e8418d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Yakima Valley Memorial",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ef853cc1-94e4-4ed7-883a-9be7485e458e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "San Antonio Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4034ed0f-c20d-41d3-8c75-4fd876e23d84/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Pedro J. Carvajal, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/433d186d-e7ed-4937-b3fc-cb398ca4e3d1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "University of Miami",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/64693d89-5bd3-4779-97cc-8ea039f4d84a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sparrow Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/96bf28ff-9478-4d5b-b771-10fa60d84e3e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Youngstown University",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a959ef80-14bc-4ebe-a72a-ac90e6dfb7c1/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Nephrology Consultants, PA",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3c97fd5e-8596-4941-825c-71277aadd345/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Petersburg Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5118b28a-7a06-4865-8078-64025151437b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Northwest Health - La Porte",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b74030e2-5e2c-4fcc-af5e-0e1218937dd3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wombkeepers AZ Obstetrics and Gynecology, PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e8e8bad8-b3b5-4f34-b7c8-aa8579a771d2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Felix Stanziola, MD",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a64bacdf-7122-42ec-b408-85ca6a1c0d9d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Morehead State University",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d926698c-9c76-4ade-b66a-6537e101538b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Salem Memorial District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/7fa95236-8ac0-416b-a8ed-2e866ba26ee3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "RMS Healthcare Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a1043923-9a03-4091-af1d-8ba05128ac18/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rock Regional Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2563cb1b-8ed5-4fa8-82ee-eb933a99c9c2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blue Cross and Blue Shield of Vermont",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d03e2bb3-d17a-409b-bb16-d2cf8d81bb7f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lake Washington Center for Cardiovascular Disease PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/8717a3df-3396-4fec-bfa3-724001fec2f0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Bonham's Insurance Filing Service",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/84748ab4-7da2-4e64-a47a-bced04040967/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Blue Cross and Blue Shield of Vermont",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5e1b8265-3ddf-4d25-828e-60aff679773e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Premier Medical Group Of California",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c8f45fa0-e85f-40b9-9ed7-e942e5e7dfff/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Brian J. Lipman M.D PC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d632725e-d12a-4178-a468-d2bf3b7c775c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Executive Health of Coral Gables",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3ed38101-a312-4a4c-8cad-0627a5c63d9e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "WellPath",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ca02c823-7600-4deb-87ac-1a00a1f8f2a3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mercy Medical Center - Des Moines",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/83b42fa0-a249-40c9-aee4-6a0b70e02e38/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "City of Virginia Beach",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/9229a1fd-2cd1-41dc-9da8-258046291286/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tri-City Mental Health Authority",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a64573bd-48d1-453d-bc0b-03ac15ad915e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "The Steven A. Cohen Military Family Clinic At Hope For The Warriors",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b42e48de-7b98-4d90-940b-5df7b37922b0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Steven A. Cohen Military Family Clinic At Red Rock",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b3b1f767-47ed-4b48-a4ad-d6b16e6b1d96/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "Okanogan County Public Hospital District No 4 d/b/a North Valley Hospital District",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3886e5cc-74f6-4658-9302-8c8ffe285776/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mount Desert Island Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b5eba017-85d4-4b6c-a2f0-9b2c7b0c38dd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Saunders Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/06e9d567-9657-447f-97fb-d967654387e7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Five Mountains Hawaii, Inc- Dba: Kipuka o ke Ola",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/17479dfb-b021-49d0-9c8a-9247a410a2a3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Tropical Texas Behavioral Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2806d8de-ae12-4b18-ae66-9968e4959f3b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Down East Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6b68bc92-a317-4686-a79a-fbb1b58a509e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Avala Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6b993c00-9c88-470f-88b4-6f0fe190a331/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Steven A. Cohen Military Family Clinic At Valley Cities",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c94ce1de-8ba2-4394-973b-793fb06a2e01/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Union Hospital Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6c5673bf-1576-4b76-b281-a10d81e39c32/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Country Hospital & Health Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4a15a283-6747-4ef7-984f-ce0e904fd6f0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mission Vascular and Vein Institute",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6ced2343-be23-4638-ae8b-2d350b5289bb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Morris County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d20ca4de-00bb-48dc-a30c-dec35eefeee0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Steven A. Cohen Military Family Clinic At Metrocare",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4402b652-4a96-42fb-a377-6cc6100998fc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Odessa Medical Enterprises, PLLC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/86d17ea7-c0d4-4a9e-851b-e7036c82ae16/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Many Rivers Whole Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2229c7e9-33af-4844-8811-015c0ae6032b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mineral Community Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/dc5f8db7-e9a3-4070-8bcb-b87b0fc836dc/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "NeuroPsychiatric Hospitals",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/81ae421e-0273-40bd-85b5-5e4a188d476b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jewish Family Services of Atlantic and Cape May Counties",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/da70f33d-e31d-497a-8eef-34fb466312cb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "North Canton Podiatry Inc",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4d4f1d55-8274-42f9-8e8e-37c848659018/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Sapphire Community Health, Inc.",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b2651172-99ed-43dd-9814-59d9dbd8df43/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "The Steven A. Cohen Military Family Clinic At Child & Family Service",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2b6bf215-e418-4787-a3e4-daea65e4cf1a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Steven A. Cohen Military Family Clinic At The Up Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c4f2491a-95ed-4fe6-a71d-a2eb4e47373a/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Memorial Hospital of Carbon County",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/df6c8393-ac58-4a86-8a27-38dc34fcee7e/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital:
      "The Steven A. Cohen Military Family Clinic At The University Of Pennsylvania",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/429a252c-d8ed-49c2-a7fe-d64be676fdca/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Steven A. Cohen Military Family Clinic At Easterseals",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ea58a6c7-91a7-4c12-b7a2-85fb3bc9550c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Littleton Hospital Association D/B/A LRH",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/09f87210-eeaa-4491-a502-556546cf5c51/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Brown County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f24ac13d-3953-486e-b046-3f6f7cc41dd9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Miners' Colfax Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1762c86e-d105-4afc-a3d1-9e89748c9af3/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Milton Hershey School",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/62b49e98-30bd-422f-99ce-a2bf06848427/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Orthopedic and Sports Medicine Specialists of Green Bay, SC",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/0cda6ed7-9e18-4112-ab11-d5a45a40c8d5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Gros Ventre OB/GYN",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4ea2101b-bb2d-4211-bc53-3120cb72bcc5/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Archbold Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/66097e3b-7cef-4b96-acca-38bfaae85903/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Iron County Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/3585fb85-29d2-4cc4-ba39-28265125f97f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Indiana Foot & Ankle Specialist",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/474ddf0e-e459-4fdc-bb00-29da6ac3f85d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "El Centro Regional Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1511ffe1-3474-454c-96b9-25125c8182f0/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Unified Health Associates",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/adcf8c94-9b00-4842-a377-0e772d7d3145/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Ansari Pediatrics",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/75356e65-cb1f-4ae8-8e4b-769ebb19838c/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "First Baptist Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/58cb9d91-2948-4de3-bf50-27f99b3c33d9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Lincoln Community Hospital and Nursing Home",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/612049ca-ad54-424a-803a-7ad03f0a9824/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "South Central Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/e2ca5a14-2e79-4b49-ba4a-3cc6ac280cc6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Madelia Community Hospital and Clinic (D/B/A Madelia Health)",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f2aa0e6f-59f8-4af5-916b-5f2f9445c1cb/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "American Cardiology",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f9dfebfc-b50e-4045-a2f3-bb8ed7deceb7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Callaway District Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d20828fa-18c8-4d75-9900-c8e656d360ce/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Norton County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/47504f24-8f33-46ef-bd43-36455bc94e0b/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wayne General Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c57b8fef-3c95-4d31-a1ba-989525848740/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rehabilitation Hospital of the Pacific",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/ba83b482-215a-4958-9629-47fddfaae0e6/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Changing Tides Family Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/eef7bdb7-cd7b-4ec1-b846-cf9ec1db80c8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Mosaic Mental Health",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/507190e3-553c-45ab-80f1-7f5686edd221/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Coryell Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/b521788a-adbe-4a3e-b071-9a158daabf49/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "California Coast Physicians",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/4ba49078-9665-4e9e-a0c8-bbc03a3add1d/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Kearney County Health Services",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/afb10dcd-fcfe-4394-bcee-f9c44a02df40/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Wills Memorial Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/2e91391f-862e-482e-a486-1862f5b91400/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "CareWell Health Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/a65c889c-5800-4966-9f18-2b11c55e40a9/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Caribou Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/1c1a9f5d-79fb-4003-8c99-6287771c0404/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Jeff Davis Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/f98028ac-bce8-4115-85e2-9556668ed9dd/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Noxubee Medical Complex",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/71747401-1366-4bfa-a42b-aee2082f7da8/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Eastern Plumas Health Care",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/91ce0f5a-eaec-4ac5-8575-4a3202e9921f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Drew Memorial Health System",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/5688c8fc-5826-44b1-99d0-6246f74da8b2/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Madison Valley Medical Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/c11411f4-01ed-4048-962f-685091adad2f/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "The Resource Center",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/6045c542-91fb-42f0-88cd-540b035e6ca7/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
  {
    Hospital: "Rock County Hospital",
    Endpoint:
      "https://fhir-myrecord.cerner.com/r4/d4a56ff5-f6ae-4ca3-b326-1973b3579459/",
    "Include in Platform": "YES",
    platform: "Cerner",
  },
];

export default [...cernerOrgListR4, ...orgListR4];
// export default [...cernerOrgListR4];
